/* eslint-disable */
import React, { useState, useContext, useRef, useMemo } from 'react';
import { Data } from './contexts';
import { Responsive, WidthProvider } from 'react-grid-layout';
import ChildDashboard from './ChildDashboard';
import { MonthlyPNLandBalValues, YTDPnlandBalCommonSizeValue, AnnualCashFlowValues, MonthlyCashFlowValues, AnnualKFIsValues, YTDPnlandBalValues, YTDCashFlowValues, MonthlyKFIsValues } from './report_components/MoneyHelpers';
import { objReducer, calculateKFIMetric, calculateSeniorDebtToEBITDA, calculateEBITDAtoAnnualInterest, monthlyTotalRevenueGRCalc, monthlyPercentOfRevenueCalc, ytdPercentOfRevenueCalc, ytdTotalRevenueGRCalc } from './report_components/MoneyHelpers';
import { buildImpactBox, impactBoxStatusColor, noSpecificTextMaker } from './report_components/ImpactBoxTextHelper';
import { ratioCalculations, netWorkingCapitalCalculation, netWorkingCapitalRatioCalculation, trailing12MonthCalculations } from './monthly/monthy_analysis_table_trailing12_calculations';
import { peopleCustomersT12Metrics, peersAnalysisPerCustomerVals } from './report_components/PeopleCustomersHelpers';
import { COPY } from './charts/chart_helpers';
import { moneyCharts, pageCharts } from './charts';
import { revenueDisplay, expensesDisplay, revenueTop10Chart, expensesTop10Chart, revAndOpexAreaChartOptions, revAndOpexLineChartOptions } from './RevenueOpexChartItems';
import { gaugeKeys, getMultiDataBarChartOptions, get3DBubbleChartOptions, getQuadrantOptions, getScatterPlotOptions, getPNLComboOptions, getTrendChart, getGaugeOptions, getPieOptions, getDonutOptions, format, getLineOrColOptions, getVerticalBarChartOptions, getHorizontalBarOptions, getStackedColumnOptions, getLineChartOptions } from './charts/DashBoardHighChartsHelper';
import getUSMapOptions from './charts/HighChartsUSmap';
import WageDataScaffold from './tables/WageDataScaffold';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highcharts.js';
import highchartsMore from 'highcharts/highcharts-more.js';
import highchartsMap from 'highcharts/modules/map';
import solidGauge from 'highcharts/modules/solid-gauge.js';
import HC_exporting from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';
import drilldown from 'highcharts/modules/drilldown';
import { capitalize, parseMoney } from '../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen, faLock, faPencil } from '@fortawesome/free-solid-svg-icons';
const ResponsiveGridLayout = WidthProvider(Responsive);
highchartsMore(Highcharts);
highchartsMap(Highcharts);
solidGauge(Highcharts);
HC_exporting(Highcharts);
offlineExporting(Highcharts);
drilldown(Highcharts);

const getYTDMonths = (data, ytdMonths) => {
  if (!data || !Array.isArray(ytdMonths)) return [];
  return ytdMonths.map((m) => data[m]);
};

const monthsList = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const compareWithRowKeys = {
  'Peers - Top 10% Fastest Growing': 'top_10_revenue_growth',
  'Peers - Top 25% Fastest Growing': 'top_25_revenue_growth',
  'Peers - Top 10% Most Profitable': 'top_10_net_profit',
  'Peers - Top 25% Most Profitable': 'top_25_net_profit'
}

const ParentDashboard = (props) => {
  const { peerviewMetricsYears, calcs, monthly_calcs, trailing12, ytd_months } = useContext(Data);
  const avgAnnualCalcs = props.aggregateData ? props.aggregateData?.annual : calcs
  const monthlyCalcs = props.reportPeriod === 'Trailing 12' ? trailing12 : monthly_calcs;
  const avgMonthlyCalcs = props.aggregateData && props.report_period === 'Trailing 12' ? props.aggregateData?.trailing12 : props.aggregateData ? props.aggregateData?.monthly : monthlyCalcs;
  let selectedYear = props.year;
  let previousYear = props.year - 1;
  let twoYearsAgo = props.year - 2;
  let threeYearsAgo = props.year - 3;
  const endMonthOfSelectedYear = props?.tabFilters?.date_through_monthly_month && props?.tabFilters?.date_through_monthly_year ? Number(props?.tabFilters?.date_through_monthly_month) : 12;
  const [chartRefs, setChartRefs] = useState({})
  const [layout, setLayout] = useState(props.dashboardLayout || []);
  // Get an object of all the highcharts refs so that they reflow() or force resizing when user resizes them in the react-grid-layout
  const setNewRef = (ref) => {
    if (ref) {
      let itemId = ref.container.current.id;
      chartRefs[itemId] = ref;
      setChartRefs(prevState => {
        return {
          ...prevState,
          itemId: ref
        }
      })
    }
  };

  const titleSetter = (chart) => {
    if (props.displayColumnsBy === 'Months' && chart.key === 'total_revenue_growth_rate') {
      return 'Monthly Revenue % of Annual Total Revenue'
    } else if (chart.copy) {
      if (chart.key.includes('labor_cogs')) {
        return `Labor COGS - ${chart.copy}`
      } else if (chart.parentKey === "total_costs") {
        return `COGS-${chart.copy}`
      } else {
        return chart.copy
      }
    } else {
      return (chart.title ? chart.title : COPY[chart.key])
    }
  }

  const buildHorizonalBarSeries = (chart) => {
    if (props.page === 'industryCustomers') {
      let vals = chart.keys.map((key) => {
        let val = calcs['avg'][key][props.year];
        return val ? (Math.round(val * 10) / 10) : null;
      })

      return [{
        data: vals,
        showInLegend: false,
        name: 'avg',
        color: '#542667',
      }]

    } else {
      if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
        return ['you', 'avg'].map((g, i) => {
          let dataCalcs = g == 'avg' ? avgAnnualCalcs : calcs
          let dataName = g === 'avg' ? 'Peers' : 'You';
          let vals = chart.keys.map((key) => {
            let val = dataCalcs[g][key][props.year];
            return val ? (Math.round(val * 10) / 10) : null;
          })

          return {
            data: vals,
            showInLegend: true,
            name: dataName,
            color: dataName === 'You' ? '#542667' : '#ae6dc9',
          }
        })
      }

      return ['you', 'avg'].map((g, i) => {
        let dataName = g === 'avg' ? 'Peers' : 'You';

        return {
          data: [0, 0],
          showInLegend: true,
          name: dataName,
          color: dataName === 'You' ? '#542667' : '#ae6dc9',
        }
      })
    }
  }

  const buildLineSeries = (chart) => {
    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
      return ['you', 'avg'].map((g, i) => {
        let dataCalcs = g == 'avg' ? avgAnnualCalcs : calcs
        let dataName = g === 'avg' ? 'Peers' : 'You';
        let vals = chart.keys.map((key) => {
          // need latest year for cltv70, 80, 90
          let val = dataCalcs[g][key][props.year];
          return val ? val : null;
        })

        return {
          data: vals,
          showInLegend: true,
          name: dataName,
          title: dataName,
          color: dataName === 'You' ? '#542667' : '#ae6dc9',
          _symbolIndex: i,
        }
      })
    }
    return ['you', 'avg'].map((g, i) => {
      let dataName = g === 'avg' ? 'Peers' : 'You';

      return {
        data: [0, 0],
        showInLegend: true,
        name: dataName,
        color: dataName === 'You' ? '#542667' : '#ae6dc9',
      }
    })
  }

  const buildVerticalBarData = (chart, set) => {
    let value = null;
    if (props.displayColumnsBy !== 'Months' && props.reportPeriod !== 'Year to Date') {
      if (set === 'you' && calcs['you']) {
        value = calcs['you']?.[chart.key]?.[props.year];
      }
      if (set === 'Peers' && avgAnnualCalcs['avg']) {
        value = avgAnnualCalcs['avg']?.[chart.key]?.[props.year];
      }

      if (compareWithRowKeys[set] && avgAnnualCalcs[compareWithRowKeys[set]]) {
        value = avgAnnualCalcs[compareWithRowKeys[set]]?.[chart.key]?.[props.year];
      }

      if (set === 'YOY' && calcs['you']) {
        value = calcs['you']?.[chart.key]?.[props.year - 1];
      }
      if (set === 'Practice' && avgAnnualCalcs['practice_avg']) {
        value = avgAnnualCalcs['practice_avg']?.[chart.key]?.[props.year];
      }
      if (set === 'NSCHBC' && avgAnnualCalcs['nschbc']) {
        value = avgAnnualCalcs['nschbc']?.[chart.key]?.[props.year];
      }

    } else {
      let monthNumber = 0;
      let metrics = set === 'you' ? props.youMetrics : props.compareMetrics;
      let useableMonths;
      if (props.displayColumnsBy === 'Months') {
        useableMonths = monthlyCalcs?.['you']?.['roa']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['roa']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
        useableMonths.forEach(thing => thing !== null ? monthNumber += 1 : null);
      } else if (props.reportPeriod === 'Year to Date') {
        useableMonths = ytd_months;
        monthNumber = ytd_months[ytd_months.length - 1]
      }
      if (metrics[chart.key]) {
        value = Math.round(metrics[chart.key][monthNumber]);
      }
    }

    return value;
  }

  const getCalcsGroupAnnual = (groupKey) => {
    const useAggregate = !['you', 'yoy'].includes(groupKey);
    return useAggregate ? avgAnnualCalcs?.[groupKey] : calcs?.you;
  };

  const getCalcsGroupMonthly = (groupKey) => {
    const useAggregate = !['you', 'yoy'].includes(groupKey);
    return useAggregate ? avgMonthlyCalcs?.[groupKey] : monthlyCalcs?.you;
  };

  // People You and Peers/Compare Stacked Column Chart
  const buildPeopleExpenses = (chart) => {
    let returnSeries;
    let firstData = [];
    let secondData = [];
    let thirdData = [];
    let fourthData = [];
    let fifthData = [];
    let sixthData = [];
    let seventhData = [];
    let eigthData = [];
    let compensation = 'total_compensation';
    let taxes = 'total_taxes_and_benefits';
    let corporateCulture = 'total_corporate_culture';
    let subcontractor = 'subcontractor_expenses';
    let professionalFees = 'people_misc_professional_fees';
    let cogsPresent = true;
    let cogsCompensation = 'labor_cogs_compensation';
    let cogsTaxes = 'labor_cogs_taxes_and_benefits';
    let cogsSubcontractor = 'cogs_subcontractors';
    let groups = ['you']
    let compareYear;

    if (props.compareWith === 'Peers') {
      groups.push('avg')
      compareYear = selectedYear
    } else if (compareWithRowKeys[props.compareWith]) {
      groups.push(compareWithRowKeys[props.compareWith])
      compareYear = selectedYear
    } else if (props.compareWith === 'Practice') {
      groups.push('practice_avg')
      compareYear = selectedYear
    } else if (props.compareWith === 'NSCHBC') {
      groups.push('nschbc')
      compareYear = selectedYear
    } else {
      groups.push('yoy')
      compareYear = previousYear
    }

    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
      groups.forEach(g => {
        const groupCalcs = getCalcsGroupAnnual(g);
        firstData.push(groupCalcs?.[compensation + '_common_size_revenue']?.[props.year])
        secondData.push(groupCalcs?.[taxes + '_common_size_revenue']?.[props.year])
        thirdData.push(groupCalcs?.[corporateCulture + '_common_size_revenue']?.[props.year])
        fourthData.push(groupCalcs?.[subcontractor + '_common_size_revenue']?.[props.year])
        fifthData.push(groupCalcs?.[professionalFees + '_common_size_revenue']?.[props.year])

        if (groupCalcs?.[cogsCompensation + '_common_size_revenue']?.[props.year]) {
          sixthData.push(groupCalcs?.[cogsCompensation + '_common_size_revenue']?.[props.year])
          seventhData.push(groupCalcs?.[cogsTaxes + '_common_size_revenue']?.[props.year])
          eigthData.push(groupCalcs?.[cogsSubcontractor + '_common_size_revenue']?.[props.year])
        } else {
          cogsPresent = false
        }
      })
    }

    if (props.reportPeriod === 'Year to Date') {
      groups.forEach(g => {
        let totalRevenueValue = 0;
        const groupCalcs = getCalcsGroupMonthly(g);
        if (groupCalcs?.['total_revenue']?.[props.year]) {
          totalRevenueValue = Object.values(groupCalcs['total_revenue'][props.year]).reduce((a, b) => a + b);
          let firstVal = groupCalcs?.[compensation]?.[props.year] ? getYTDMonths(groupCalcs[compensation][props.year], ytd_months).reduce((a, b) => a + b) : 0;
          let secondVal = groupCalcs?.[taxes]?.[props.year] ? getYTDMonths(groupCalcs[taxes][props.year], ytd_months).reduce((a, b) => a + b) : 0;
          let thirdVal = groupCalcs?.[corporateCulture]?.[props.year] ? getYTDMonths(groupCalcs[corporateCulture][props.year], ytd_months).reduce((a, b) => a + b) : 0;
          let fourthVal = groupCalcs?.[subcontractor]?.[props.year] ? getYTDMonths(groupCalcs[subcontractor][props.year], ytd_months).reduce((a, b) => a + b) : 0;
          let fifthVal = groupCalcs?.[professionalFees]?.[props.year] ? getYTDMonths(groupCalcs[professionalFees][props.year], ytd_months).reduce((a, b) => a + b) : 0;
          firstData.push(firstVal / totalRevenueValue)
          secondData.push(secondVal / totalRevenueValue)
          thirdData.push(thirdVal / totalRevenueValue)
          fourthData.push(fourthVal / totalRevenueValue)
          fifthData.push(fifthVal / totalRevenueValue)

          if (groupCalcs?.[cogsCompensation]) {
            let sixthVal = groupCalcs?.[cogsCompensation]?.[props.year] ? getYTDMonths(groupCalcs[cogsCompensation][props.year], ytd_months).reduce((a, b) => a + b) : 0;
            let seventhVal = groupCalcs?.[cogsTaxes]?.[props.year] ? getYTDMonths(groupCalcs[cogsTaxes][props.year], ytd_months).reduce((a, b) => a + b) : 0;
            let eighthVal = groupCalcs?.[cogsSubcontractor]?.[props.year] ? getYTDMonths(groupCalcs[cogsSubcontractor][props.year], ytd_months).reduce((a, b) => a + b) : 0;
            sixthData.push(sixthVal / totalRevenueValue)
            seventhData.push(seventhVal / totalRevenueValue)
            eigthData.push(eighthVal / totalRevenueValue)
          } else {
            cogsPresent = false
          }
        }
      })
    }

    if (props.displayColumnsBy === 'Months') {
      groups.forEach(g => {
        let year = g === 'you' ? selectedYear : compareYear;
        const groupCalcs = getCalcsGroupMonthly(g);

        let totalRevenueValue = 0;
        if (groupCalcs?.['total_revenue']) {
          totalRevenueValue = Object.values(groupCalcs['total_revenue']?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b);
          let firstVal = groupCalcs[compensation] ? Object.values(groupCalcs[compensation]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
          let secondVal = groupCalcs[taxes] ? Object.values(groupCalcs[taxes]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
          let thirdVal = groupCalcs[corporateCulture] ? Object.values(groupCalcs[corporateCulture]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
          let fourthVal = groupCalcs[subcontractor] ? Object.values(groupCalcs[subcontractor]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
          let fifthVal = groupCalcs[professionalFees] ? Object.values(groupCalcs[professionalFees]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
          firstData.push(firstVal / totalRevenueValue)
          secondData.push(secondVal / totalRevenueValue)
          thirdData.push(thirdVal / totalRevenueValue)
          fourthData.push(fourthVal / totalRevenueValue)
          fifthData.push(fifthVal / totalRevenueValue)

          if (groupCalcs[cogsCompensation]) {
            let sixthVal = groupCalcs[cogsCompensation] ? Object.values(groupCalcs[cogsCompensation]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
            let seventhVal = groupCalcs[cogsTaxes] ? Object.values(groupCalcs[cogsTaxes]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
            let eighthVal = groupCalcs[cogsSubcontractor] ? Object.values(groupCalcs[cogsSubcontractor]?.[year]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b) : 0;
            sixthData.push(sixthVal / totalRevenueValue)
            seventhData.push(seventhVal / totalRevenueValue)
            eigthData.push(eighthVal / totalRevenueValue)
          } else {
            cogsPresent = false
          }
        }
      })
    }

    let cogsData = [
      {
        name: 'COGS - Compensation',
        color: '#ffda58',
        data: sixthData
      },
      {
        name: 'COGS - Taxes & Benefits',
        color: '#f14d4d',
        data: seventhData
      },
      {
        name: 'COGS - Subcontractor',
        color: '#BA68C8',
        data: eigthData
      },
    ]

    let peopleExpensesData = [
      {
        name: 'Compensation',
        color: '#ffb74d',
        data: firstData
      },
      {
        name: 'Taxes & Benefits',
        color: '#999',
        data: secondData
      },
      {
        name: 'Corporate Culture',
        color: '#542667',
        data: thirdData
      },
      {
        name: 'Subcontractor Expenses',
        color: '#00aeef',
        data: fourthData
      },
      {
        name: 'Professional Fees - HR',
        color: '#69b144',
        data: fifthData
      },
    ];

    return cogsPresent ? [...cogsData, ...peopleExpensesData] : peopleExpensesData
  }

  // Used by AP and AR Aging Summary Reports
  const buildAPARAgingSeries = (chart) => {
    let returnSeries;
    let firstData = [];
    let secondData = [];
    let thirdData = [];
    let fourthData = [];
    let currentData = [];
    let apOrAr = chart.key === 'ap_aging_summary' ? 'ap' : 'ar';
    let agingKey91Over = apOrAr + '_91_and_over';
    let agingKey6191 = apOrAr + '_61_90';
    let agingKey3160 = apOrAr + '_31_60';
    let agingKey130 = apOrAr + '_1_30';
    let agingKeyCurrent = apOrAr + '_current';

    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
      chart.years.forEach(year => {
        firstData.push(calcs['you'][agingKey91Over][year])
        secondData.push(calcs['you'][agingKey6191][year])
        thirdData.push(calcs['you'][agingKey3160][year])
        fourthData.push(calcs['you'][agingKey130][year])
        currentData.push(calcs['you'][agingKeyCurrent][year])
      })
    }

    if (props.reportPeriod === 'Year to Date') {
      chart.years.forEach(year => {
        let firstVals = monthlyCalcs['you']?.[agingKey91Over]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey91Over][year], ytd_months) : [];
        let secondVals = monthlyCalcs['you']?.[agingKey6191]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey6191][year], ytd_months) : [];
        let thirdVals = monthlyCalcs['you']?.[agingKey3160]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey3160][year], ytd_months) : [];
        let fourthVals = monthlyCalcs['you']?.[agingKey130]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKey130][year], ytd_months) : [];
        let currentVals = monthlyCalcs['you']?.[agingKeyCurrent]?.[year] ? getYTDMonths(monthlyCalcs['you'][agingKeyCurrent][year], ytd_months) : [];
        firstData.push(firstVals[firstVals.length - 1])
        secondData.push(secondVals[secondVals.length - 1])
        thirdData.push(thirdVals[thirdVals.length - 1])
        fourthData.push(fourthVals[fourthVals.length - 1])
        currentData.push(currentVals[currentVals.length - 1])
      })
    }

    if (props.displayColumnsBy === 'Months') {
      firstData = Object.values(monthlyCalcs['you']?.[agingKey91Over]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
      secondData = Object.values(monthlyCalcs['you']?.[agingKey6191]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
      thirdData = Object.values(monthlyCalcs['you']?.[agingKey3160]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
      fourthData = Object.values(monthlyCalcs['you']?.[agingKey130]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
      currentData = Object.values(monthlyCalcs['you']?.[agingKeyCurrent]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
    }

    return [
      {
        name: '91 and over',
        color: '#ffb74d',
        data: firstData
      },
      {
        name: '61-90',
        color: '#999',
        data: secondData
      },
      {
        name: '31-60',
        color: '#542667',
        data: thirdData
      },
      {
        name: '1-30',
        color: '#00aeef',
        data: fourthData
      },
      {
        name: 'Current',
        color: '#69b144',
        data: currentData
      }
    ];
  }

  const peoplePercentKeys = ['sum_compensation_growth_rate', 'sum_taxes_and_benefits_growth_rate', 'sum_subcontractors_growth_rate', 'turnover_rate']
  const peopleKpiT12 = ['total_revenue_per_employee', 'operating_expenses_net_income_per_employee', 'average_wages_and_salaries', 'average_benefits', 'cost_of_turnover', 'number_of_employees_who_left', 'sum_compensation_growth_rate', 'sum_compensation_per_employee', 'sum_health_insurance_per_employee', 'sum_payroll_per_employee', 'sum_retirement_per_employee', 'sum_subcontractors_growth_rate', 'sum_taxes_and_benefits_growth_rate', 'sum_taxes_and_benefits_per_employee', 'total_number_of_employees', 'training_per_employee', 'turnover_rate']
  const customerKPIKeys = ['revenue_per_customer', 'gross_profit_per_customer', 'operating_expenses_net_income_per_customer', 'total_customer_costs_common_size_revenue', 'number_of_new_customers_needed_to_maintain_growth']
  const customerPercentKeys = ['percent_of_sales_from_the_top_10_percent', 'percent_of_sales_from_the_top_25_percent', 'percent_of_sales_from_the_top_50_percent', 'customer_roi']
  const buildYouLineOrColData = (chart, sheet = '') => {
    const key = chart.key;
    let dataMap = [];
    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
      dataMap = chart.years.map(year => {
        let value;
        try {
          if (key === 'net_working_capital') {
            let totalCurrentAssets = calcs['you']['total_current_assets'][year];
            let totalCurrentLiabilities = calcs['you']['total_current_liabilities'][year];
            value = totalCurrentAssets - totalCurrentLiabilities;
          } else if (key === 'senior_debt_to_ebitda') {
            let longTermDebt = calcs['you']['long_term_debt'][year];
            let lineOfCredit = calcs['you']['line_of_credit'][year];
            let currentPortionOfLTD = calcs['you']['current_portion_of_ltd'][year];
            let netIncome = calcs['you']['operating_expenses_net_income'][year];
            let interest = calcs['you']['interest_and_other_expenses'][year];
            let taxes = calcs['you']['total_other_costs_taxes_- federal & state'][year];
            let deprAmor = calcs['you']['depreciation_and_amortization'][year];
            let ebitda = netIncome + interest + taxes + deprAmor;
            value = (longTermDebt + lineOfCredit + currentPortionOfLTD) / ebitda;
          } else if (key === 'ebitda_to_annual_interest') {
            let netIncome = calcs['you']['operating_expenses_net_income'][year];
            let interest = calcs['you']['interest_and_other_expenses'][year];
            let taxes = calcs['you']['total_other_costs_taxes_- federal & state'][year];
            let deprAmor = calcs['you']['depreciation_and_amortization'][year];
            let ebitda = netIncome + interest + taxes + deprAmor;
            value = ebitda / interest;
          } else if (customerKPIKeys.includes(key)) {
            value = calcs['you'][key][year]
          } else if (customerPercentKeys.includes(key) || peoplePercentKeys.includes(key)) {
            value = calcs['you'][key][year] / 100
          } else if (sheet === 'pnl' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
            value = calcs['you'][key + '_common_size_revenue'][year]
          } else if (sheet === 'balance_sheet') {
            value = calcs['you'][key + '_common_size_assets'][year]
          } else {
            value = calcs.you[key][year];
          }
          return value ? value : null;
        } catch (e) {
          return null;
        }
      })
    }

    if (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') {
      if (props.page === 'money' || props.page === 'people' || props.page === 'customers') {
        dataMap = chart.years.map(year => {
          try {
            if (chart.percentOfRevenueKey) {
              let value = ytdPercentOfRevenueCalc(chart.percentOfRevenueKey, key, monthlyCalcs['you'], year, ytd_months);
              return value;
            } else if (key === 'senior_debt_to_ebitda') {
              let value = calculateSeniorDebtToEBITDA(monthlyCalcs['you'], year, ytd_months)
              return value;
            } else if (key === 'ebitda_to_annual_interest') {
              let value = calculateEBITDAtoAnnualInterest(monthlyCalcs['you'], year, ytd_months)
              return value;
            } else if (key === 'total_revenue_growth_rate') {
              let totalRevenueGR = ytdTotalRevenueGRCalc(monthlyCalcs['you'], year, year - 1, ytd_months)
              return totalRevenueGR;
            } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
              let lastMonthNumber = ytd_months[ytd_months.length - 1]
              let useableMonths = ytd_months
              let t12Obj = peopleCustomersT12Metrics(page, key, monthlyCalcs.you, year, year - 1, year - 2, true, ytd_months, 'you')
              return t12Obj[key][lastMonthNumber]
            } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
              const currentYearYTDYou = monthlyCalcs?.you?.[key]?.[year];
              let value = YTDPnlandBalValues(sheet, key, currentYearYTDYou, year, ytd_months, monthlyCalcs?.you)
              let finalVal = YTDPnlandBalCommonSizeValue(value, sheet, year, ytd_months, monthlyCalcs?.you)
              return finalVal;
            } else {
              let value = calculateKFIMetric(key, monthlyCalcs['you'], year, year - 1, ytd_months)
              return value;
            }
          } catch (e) {
            return null;
          }
        })
      } else {
        let selectedYearVal, previousYearVal = null;
        let lastMonthNumber = ytd_months[ytd_months.length - 1]
        let useableMonths = ytd_months

        if (key === 'total_revenue' || key === 'gross_profit' || key === 'operating_expenses_net_income') {
          selectedYearVal = getYTDMonths(monthlyCalcs['you'][key][props.year], ytd_months).reduce((a, b) => a + b, 0);
          previousYearVal = getYTDMonths(monthlyCalcs['you'][key][props.year - 1], ytd_months).reduce((a, b) => a + b, 0);
        } else {
          if (props.youMetrics[key]) {
            selectedYearVal = props.youMetrics[key][monthNumber];
          }
          if (props.youPreviousYearMetricsYTD[key]) {
            previousYearVal = props.youPreviousYearMetricsYTD[key][monthNumber];
          }
        }
        dataMap = [previousYearVal, selectedYearVal]
      }
    }

    if (props.displayColumnsBy === 'Months') {
      let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      if (props.page === 'money' || props.page === 'people' || props.page === 'customers') {
        if (chart.trailing12Key) {
          let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, monthlyCalcs.you, selectedYear, previousYear);
          dataMap = Object.values(trailing12Obj).slice(0, endMonthOfSelectedYear);
        } else if (chart.percentOfRevenueKey) {
          let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, monthlyCalcs.you, selectedYear);
          dataMap = Object.values(percentOfRevenueObj).slice(0, endMonthOfSelectedYear);
        } else if (key === 'current_ratio') {
          let currentRatioObj = ratioCalculations('total_current_assets', monthlyCalcs.you, selectedYear)
          dataMap = Object.values(currentRatioObj).slice(0, endMonthOfSelectedYear);
        } else if (key === 'net_working_capital_ratio') {
          let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(monthlyCalcs.you, selectedYear)
          dataMap = Object.values(netWorkingCapRatioObj).slice(0, endMonthOfSelectedYear);
        } else if (key === 'net_working_capital') {
          let netWorkingCapitalObj = netWorkingCapitalCalculation(monthlyCalcs.you, selectedYear)
          dataMap = Object.values(netWorkingCapitalObj).slice(0, endMonthOfSelectedYear)
        } else if (key === 'total_revenue_growth_rate') {
          let totalRevenueGR = monthlyTotalRevenueGRCalc(monthlyCalcs.you, selectedYear)
          dataMap = Object.values(totalRevenueGR).slice(0, endMonthOfSelectedYear);
        } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
          let t12Obj = peopleCustomersT12Metrics(props.page, key, monthlyCalcs.you, selectedYear, previousYear, twoYearsAgo)
          dataMap = Object.values(t12Obj[key]).slice(0, endMonthOfSelectedYear)
        } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
          let monthsAvailable = 0;
          let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
          useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
          const you = monthlyCalcs?.['you'] ? monthlyCalcs?.['you']?.[key]?.[selectedYear] : undefined;
          dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, you, selectedYear, monthlyCalcs['you'])
        } else {
          let returnObj = {};
          let metricValues = _.pickBy(monthlyCalcs.you[key]?.[selectedYear], _.isNumber);
          for (let month in metricValues) {
            returnObj[month] = metricValues[month]
          }
          dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
        }
      } else {
        let returnObj = {};
        let metricValues = _.pickBy(props.youMetrics?.[key], _.isNumber);
        for (let month in metricValues) {
          returnObj[month] = metricValues[month]
        }
        dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
      }
    }
    return dataMap;
  }

  const buildCompareLineOrColData = (chart, sheet = '') => {
    const key = chart.key;
    let analysisPerClientMetrics = ['revenue_per_customer', 'gross_profit_per_customer', 'operating_expenses_net_income_per_customer'];
    let dataMap = [];
    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
      dataMap = chart.years.map(year => {
        let value;
        let compareAvg = {}

        if (props.compareWith === 'Peers') {
          compareAvg = avgAnnualCalcs['avg']
        } else if (compareWithRowKeys[props.compareWith]) {
          compareAvg = avgAnnualCalcs[compareWithRowKeys[props.compareWith]]
        } else if (props.compareWith === 'Practice') {
          compareAvg = avgAnnualCalcs['practice_avg']
        } else if (props.compareWith === 'NSCHBC') {
          compareAvg = avgAnnualCalcs['nschbc']
        }

        try {
          if (key === 'net_working_capital') {
            let youTotalAssets = calcs['you']['total_assets'][year]
            let totalCurrentAssetsCommonSize = compareAvg['total_current_assets_common_size_assets'][year];
            let totalCurrentLiabilitiesCommonSize = compareAvg['total_current_liabilities_common_size_assets'][year];
            value = (totalCurrentAssetsCommonSize * youTotalAssets) - (totalCurrentLiabilitiesCommonSize * youTotalAssets);
          } else if (key === 'senior_debt_to_ebitda') {
            let longTermDebt = compareAvg['long_term_debt'][year];
            let lineOfCredit = compareAvg['line_of_credit'][year];
            let currentPortionOfLTD = compareAvg['current_portion_of_ltd'][year];
            let netIncome = compareAvg['operating_expenses_net_income'][year];
            let interest = compareAvg['interest_and_other_expenses'][year];
            let taxes = compareAvg['total_other_costs_taxes_- federal & state'][year];
            let deprAmor = compareAvg['depreciation_and_amortization'][year];
            let ebitda = netIncome + interest + taxes + deprAmor;
            value = (longTermDebt + lineOfCredit + currentPortionOfLTD) / ebitda;
          } else if (key === 'ebitda_to_annual_interest') {
            let netIncome = compareAvg['operating_expenses_net_income'][year];
            let interest = compareAvg['interest_and_other_expenses'][year];
            let taxes = compareAvg['total_other_costs_taxes_- federal & state'][year];
            let deprAmor = compareAvg['depreciation_and_amortization'][year];
            let ebitda = netIncome + interest + taxes + deprAmor;
            value = ebitda / interest;
          } else if (props.page === 'customers' && analysisPerClientMetrics.includes(key)) {
            value = peersAnalysisPerCustomerVals(key, year, compareAvg)
          } else if (customerKPIKeys.includes(key)) {
            value = compareAvg[key][year]
          } else if (customerPercentKeys.includes(key) || peoplePercentKeys.includes(key)) {
            value = compareAvg[key][year] / 100
          } else if (sheet === 'pnl' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
            value = compareAvg[key + '_common_size_revenue'] ? compareAvg[key + '_common_size_revenue'][year] : null;
          } else if (sheet === 'balance_sheet') {
            value = compareAvg[key + '_common_size_assets'] ? compareAvg[key + '_common_size_assets'][year] : null;
          } else if (key === 'cash') {
            let youTotalAssets = calcs['you']['total_assets'][year]
            value = compareAvg[key + '_common_size_assets'] ? youTotalAssets * compareAvg[key + '_common_size_assets'][year] : null;
          } else {
            value = compareAvg[key][year];
          }
          return value ? value : null;
        } catch (e) {
          return null;
        }
      })
    }

    if (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') {
      if (props.page === 'money' || props.page === 'people' || props.page === 'customers') {
        dataMap = chart.years.map(year => {
          try {
            if (chart.percentOfRevenueKey) {
              let value = ytdPercentOfRevenueCalc(chart.percentOfRevenueKey, key, avgMonthlyCalcs['avg'], year, ytd_months);
              return value;
            } else if (key === 'senior_debt_to_ebitda') {
              let value = calculateSeniorDebtToEBITDA(avgMonthlyCalcs['avg'], year, ytd_months)
              return value;
            } else if (key === 'ebitda_to_annual_interest') {
              let value = calculateEBITDAtoAnnualInterest(avgMonthlyCalcs['avg'], year, ytd_months)
              return value;
            } else if (key === 'total_revenue_growth_rate') {
              let totalRevenueGR = ytdTotalRevenueGRCalc(avgMonthlyCalcs['avg'], year, year - 1, ytd_months)
              return totalRevenueGR;
            } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
              let lastMonthNumber = ytd_months[ytd_months.length - 1]
              let useableMonths = ytd_months
              let t12Obj = peopleCustomersT12Metrics(props.page, key, avgMonthlyCalcs.avg, year, year - 1, year - 2, true, ytd_months, 'avg')
              return t12Obj[key][lastMonthNumber]
            } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
              const currentYearYTDCompare = avgMonthlyCalcs?.avg?.[key]?.[year];
              let value = YTDPnlandBalValues(sheet, key, currentYearYTDCompare, year, ytd_months, avgMonthlyCalcs?.avg)
              let finalVal = YTDPnlandBalCommonSizeValue(value, sheet, year, ytd_months, avgMonthlyCalcs?.avg)
              return finalVal
            } else {
              let value = calculateKFIMetric(key, avgMonthlyCalcs['avg'], year, year - 1, ytd_months)
              return value;
            }
          } catch (e) {
            return null;
          }
        })
      } else {
        let lastMonthNumber = ytd_months[ytd_months.length - 1]
        let useableMonths = ytd_months
        let selectedYearVal, previousYearVal = null;

        if (key === 'total_revenue' || key === 'gross_profit' || key === 'operating_expenses_net_income') {
          selectedYearVal = getYTDMonths(avgMonthlyCalcs['avg'][key][props.year], ytd_months).reduce((a, b) => a + b, 0);
          previousYearVal = getYTDMonths(avgMonthlyCalcs['avg'][key][props.year - 1], ytd_months).reduce((a, b) => a + b, 0);
        } else {
          if (props.compareMetrics[key]) {
            selectedYearVal = props.compareMetrics[key][monthNumber];
          }
          if (props.comparePreviousYearMetricsYTD[key]) {
            previousYearVal = props.comparePreviousYearMetricsYTD[key][monthNumber];
          }
        }

        dataMap = [previousYearVal, selectedYearVal]
      }
    }

    if (props.displayColumnsBy === 'Months') {
      let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

      if (props.page === 'money' || props.page === 'people' || props.page === 'customers') {
        if (chart.compareWith === 'YOY' || chart.compareWith === 'Default:YOY') {
          if (chart.trailing12Key) {
            let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, monthlyCalcs.you, previousYear, twoYearsAgo)
            dataMap = Object.values(trailing12Obj).slice(0, endMonthOfSelectedYear);
          } else if (chart.percentOfRevenueKey) {
            let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, monthlyCalcs.you, previousYear);
            dataMap = Object.values(percentOfRevenueObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'current_ratio') {
            let currentRatioObj = ratioCalculations('total_current_assets', monthlyCalcs.you, previousYear)
            dataMap = Object.values(currentRatioObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'net_working_capital_ratio') {
            let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(monthlyCalcs.you, previousYear)
            dataMap = Object.values(netWorkingCapRatioObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'net_working_capital') {
            let netWorkingCapitalObj = netWorkingCapitalCalculation(monthlyCalcs.you, previousYear)
            dataMap = Object.values(netWorkingCapitalObj).slice(0, endMonthOfSelectedYear)
          } else if (key === 'total_revenue_growth_rate') {
            let totalRevenueGR = monthlyTotalRevenueGRCalc(monthlyCalcs.you, previousYear)
            dataMap = Object.values(totalRevenueGR).slice(0, endMonthOfSelectedYear);
          } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
            let t12Obj = peopleCustomersT12Metrics(props.page, key, monthlyCalcs.you, previousYear, twoYearsAgo, threeYearsAgo)
            dataMap = Object.values(t12Obj[key]).slice(0, endMonthOfSelectedYear)
          } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
            const yoy = monthlyCalcs.you ? monthlyCalcs.you?.[key]?.[previousYear] : undefined;
            let monthsAvailable = 0;
            let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs['you']['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
            useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
            dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, yoy, previousYear, monthlyCalcs['you'])
          } else {
            let returnObj = {};
            let metricValues = _.pickBy(monthlyCalcs.you?.[key]?.[previousYear], _.isNumber);
            for (let month in metricValues) {
              returnObj[month] = metricValues[month]
            }
            dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
          }
        }

        if (chart.compareWith === 'Peers' || chart.compareWith === 'Default:Peers') {
          if (chart.trailing12Key) {
            let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, avgMonthlyCalcs.avg, selectedYear, previousYear)
            dataMap = Object.values(trailing12Obj).slice(0, endMonthOfSelectedYear);
          } else if (chart.percentOfRevenueKey) {
            let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, avgMonthlyCalcs.avg, selectedYear);
            dataMap = Object.values(percentOfRevenueObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'current_ratio') {
            let currentRatioObj = ratioCalculations('total_current_assets', avgMonthlyCalcs.avg, selectedYear)
            dataMap = Object.values(currentRatioObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'net_working_capital_ratio') {
            let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(avgMonthlyCalcs.avg, selectedYear)
            dataMap = Object.values(netWorkingCapRatioObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'net_working_capital') {
            let netWorkingCapitalObj = netWorkingCapitalCalculation(avgMonthlyCalcs.avg, selectedYear)
            dataMap = Object.values(netWorkingCapitalObj).slice(0, endMonthOfSelectedYear)
          } else if (key === 'total_revenue_growth_rate') {
            let totalRevenueGR = monthlyTotalRevenueGRCalc(avgMonthlyCalcs.avg, selectedYear)
            dataMap = Object.values(totalRevenueGR).slice(0, endMonthOfSelectedYear);
          } else if (peopleKpiT12.includes(key) || customerKPIKeys.includes(key) || key === 'customer_roi' || key === 'number_of_new_customers_needed_to_maintain_growth') {
            let t12Obj = peopleCustomersT12Metrics(props.page, key, avgMonthlyCalcs.avg, selectedYear, previousYear, twoYearsAgo)
            dataMap = t12Obj[key] ? Object.values(t12Obj[key]).slice(0, endMonthOfSelectedYear) : []
          } else if (sheet === 'pnl' || sheet === 'balance_sheet' || ['people_financial_detail', 'people_kpi', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
            const avg = avgMonthlyCalcs['avg'] ? avgMonthlyCalcs['avg']?.[key]?.[selectedYear] : undefined;
            let monthsAvailable = 0;
            let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
            useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
            dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, avg, selectedYear, avgMonthlyCalcs['avg'])
          } else {
            let returnObj = {};
            let metricValues = _.pickBy(avgMonthlyCalcs.avg?.[key]?.[selectedYear], _.isNumber);
            for (let month in metricValues) {
              returnObj[month] = metricValues[month]
            }
            dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
          }
        }

        if (chart.compareWith.includes('Forecast') && props.forecastVals?.['total_revenue']) {
          let compareSelectedYear = Object.keys(props.forecastVals?.['total_revenue'])[0]
          if (chart.trailing12Key) {
            let trailing12Obj = trailing12MonthCalculations(chart.trailing12Key, props.forecastVals, compareSelectedYear, previousYear, true, monthlyCalcs.you)
            dataMap = Object.values(trailing12Obj).slice(0, endMonthOfSelectedYear);
          } else if (chart.percentOfRevenueKey) {
            let percentOfRevenueObj = monthlyPercentOfRevenueCalc(chart.percentOfRevenueKey, key, props.forecastVals, compareSelectedYear);
            dataMap = Object.values(percentOfRevenueObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'current_ratio') {
            let numberOfMonths = 0
            let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
            useableMonths.forEach(thing => thing !== null ? numberOfMonths += 1 : null)
            let currentRatioObj = ratioCalculations('total_current_assets', props.forecastVals, compareSelectedYear)
            dataMap = Object.values(currentRatioObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'net_working_capital_ratio') {
            let netWorkingCapRatioObj = netWorkingCapitalRatioCalculation(props.forecastVals, compareSelectedYear)
            dataMap = Object.values(netWorkingCapRatioObj).slice(0, endMonthOfSelectedYear);
          } else if (key === 'net_working_capital') {
            let netWorkingCapitalObj = netWorkingCapitalCalculation(props.forecastVals, compareSelectedYear)
            dataMap = Object.values(netWorkingCapitalObj).slice(0, endMonthOfSelectedYear)
          } else if (key === 'total_revenue_growth_rate') {
            let totalRevenueGR = monthlyTotalRevenueGRCalc(props.forecastVals, compareSelectedYear)
            dataMap = Object.values(totalRevenueGR).slice(0, endMonthOfSelectedYear);
          } else if (sheet === 'pnl' || sheet === 'balance_sheet') {
            const forecast = props.forecastVals?.[key] ? props.forecastVals?.[key]?.[compareSelectedYear] : undefined;
            let monthsAvailable = 0;
            let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
            useableMonths.forEach(thing => thing !== null && !isNaN(thing) ? monthsAvailable += 1 : null);
            dataMap = MonthlyPNLandBalValues(monthsAvailable, sheet, key, forecast, compareSelectedYear, props.forecastVals)
          } else {
            let returnObj = {};
            let metricValues = _.pickBy(props.forecastVals?.[key]?.[compareSelectedYear], _.isNumber);
            for (let month in metricValues) {
              returnObj[month] = metricValues[month]
            }
            dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
          }
        }
      } else {
        let returnObj = {};
        let metricValues = _.pickBy(props.compareMetrics?.[key], _.isNumber);
        for (let month in metricValues) {
          returnObj[month] = metricValues[month]
        }
        dataMap = Object.values(returnObj).slice(0, endMonthOfSelectedYear);
      }
    }
    return dataMap
  }

  const pieExpenseTitles = {
    you: 'Your Expenses',
    avg: 'Peer Expenses',
    practice_avg: 'Practice Expenses',
    yoy: 'YOY Expenses',
    nschbc: 'NSCHBC Expenses'
  }
  let NaicsCode = window.data ? window.data.code : props.naicsCode;
  let pagePies, MoneyArrayBasedOnNAICS, CustomersArrayBasedOnNAICS;
  if (props.page === 'industryMoney' || props.page === 'money' || props.page === 'people') {
    // The Pie chart on Annual Money Report needs to display different things depending on what NAICS code the company is
    let moneyKeys = {}
    let NaicsCode3digits, NaicsCode4digits;
    NaicsCode !== undefined ? NaicsCode3digits = NaicsCode.slice(0, 3) : null
    NaicsCode !== undefined ? NaicsCode4digits = NaicsCode.slice(0, 4) : null

    if (NaicsCode === '513210SaaS') {
      let pnlChildren = props.tree?.['pnl']?.['children'] || {}
      let pnlOpexChildren = pnlChildren?.['total_operating_expenses']?.['children'] || {}
      let pnlOpexChildrenKeys = Object.keys(pnlOpexChildren)
      let cosChildren = [];

      Object.keys(pnlChildren?.['total_costs']?.['children'] || {}).forEach(child => {
        if (Object.keys(pnlChildren?.['total_costs']?.['children']?.[child] || {}).length > 0) {
          cosChildren.push({ key: child, title: pnlChildren?.['total_costs']?.['children']?.[child]?.['copy'] })
        }
      })

      pnlOpexChildrenKeys.forEach((key) => {
        if (Object.keys(pnlOpexChildren?.[key] || {}).length > 1) {
          let opexGrandChildren = []

          Object.keys(pnlOpexChildren?.[key]?.['children'] || {}).forEach(gChild => {
            opexGrandChildren.push({ key: gChild, title: pnlOpexChildren?.[key]?.['children']?.[gChild]?.['copy'] })
          })
          moneyKeys[pnlOpexChildren?.[key]?.['copy']] = opexGrandChildren
        }
      })

      moneyKeys['COS'] = cosChildren
      moneyKeys['Net Income'] = ['operating_expenses_net_income']
    } else {
      if (NaicsCode3digits === '621') {
        MoneyArrayBasedOnNAICS = ['automobile_expenses', 'bad_debt_expenses', 'computer_related_costs', 'contributions_and_donations', 'insurance_expenses', 'office_communications', 'office_expenses', 'other_operating_expenses', 'total_professional_fees', 'rent_and_facilities_costs', 'laboratory_fees', 'medical_supplies']
        CustomersArrayBasedOnNAICS = ['total_customer_costs_sales_& marketing', 'total_customer_costs_billings_& collections', 'travel_entertainment_and_meals', 'customers_misc_professional_fees']
      } else if (NaicsCode4digits === '6212') {
        MoneyArrayBasedOnNAICS = ['automobile_expenses', 'bad_debt_expenses', 'computer_related_costs', 'contributions_and_donations', 'insurance_expenses', 'office_communications', 'office_expenses', 'other_operating_expenses', 'total_professional_fees', 'rent_and_facilities_costs', 'laboratory_fees', 'dental_supplies']
        CustomersArrayBasedOnNAICS = ['total_customer_costs_sales_& marketing', 'total_customer_costs_billings_& collections', 'travel_entertainment_and_meals', 'customers_misc_professional_fees']
      } else if (NaicsCode === '713910') {
        MoneyArrayBasedOnNAICS = ['automobile_expenses', 'bad_debt_expenses', 'computer_related_costs', 'contributions_and_donations', 'insurance_expenses', 'office_communications', 'office_expenses', 'total_operations_ops_- golf', 'total_operations_ops_- food & bev', 'total_operations_ops_- sporting activities', 'total_operations_ops_- clubhouse', 'other_operating_expenses', 'total_professional_fees', 'rent_and_facilities_costs', 'warranty_expense']
        CustomersArrayBasedOnNAICS = ['sales_and_marketing', 'travel_entertainment_and_meals', 'customers_misc_professional_fees']
      } else {
        MoneyArrayBasedOnNAICS = ['automobile_expenses', 'bad_debt_expenses', 'computer_related_costs', 'contributions_and_donations', 'insurance_expenses', 'office_communications', 'office_expenses', 'other_operating_expenses', 'total_professional_fees', 'rent_and_facilities_costs', 'warranty_expense']
        CustomersArrayBasedOnNAICS = ['sales_and_marketing', 'travel_entertainment_and_meals', 'customers_misc_professional_fees']
      }

      moneyKeys['Money'] = MoneyArrayBasedOnNAICS
      moneyKeys['People'] = ['total_compensation', 'total_taxes_and_benefits', 'total_corporate_culture', 'subcontractor_expenses', 'people_misc_professional_fees']
      moneyKeys['Customers'] = CustomersArrayBasedOnNAICS
      moneyKeys['COGS'] = ['labor_costs', 'cogs_subcontractors', 'materials_costs', 'overhead', 'transportation', 'other_costs']
      moneyKeys['Net Income'] = ['operating_expenses_net_income'];
    }


    pagePies = {
      money: {
        keys: moneyKeys,
        commonSize: 'revenue',
        subtitle: '(By % of Total Revenue)'
      },

      people: {
        keys: {
          'Compensation': [{ key: 'total_compensation', title: 'OpEx Compensation' }, 'labor_cogs_compensation'],
          'Taxes and Benefits': ['labor_cogs_taxes_and_benefits', 'payroll_taxes', 'health_insurance', 'retirement_plan', 'other_taxes_and_benefits'],
          'Corporate Culture': ['recruiting', 'training', { key: 'other_corporate_culture', title: 'Other' }],
          'Subcontractor Expenses': ['cogs_subcontractors', { key: 'subcontractor_expenses', title: 'OpEx Subcontractor Expenses' }],
          'Professional Fees': ['people_misc_professional_fees'],
        },
        commonSize: 'revenue',
        subtitle: '(By % of Total Revenue)'
      }
    }

  }

  const costOfTurnover = () => {
    const lostProductivity = .2;
    const lostProductivityTime = .125;
    const lostWagesTime = .125;
    const employeeProductivityDecline = .5;
    const employeeProductivityDeclineTime = .185;

    // Cost of Turnover Formula
    // (Your Turnover Rate(year) − Peer Turnover Rate(year)) 
    // * (Number of Employees(year) 
    // * ((Revenue Per Employee(year) * Lost Productivity * Lost Productivity Time) 
    //   + (Average Wages and Salaries(year) * Lost Wages Time ) 
    //   + ((.25 * Training(year))/Number of Employees(year))
    //   + (Revenue Per Employee(year) * Employee Productivity Decline * Employee Productivity Decline Time)))

    if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
      if (calcs.you.turnover_rate[props.year] !== 0 && calcs.you.total_number_of_employees[props.year] !== 0 && calcs.you.revenue_per_employee[props.year] !== 0 && calcs.you.average_wages_and_salaries[props.year] !== 0) {
        return ((calcs.you.turnover_rate[props.year] - calcs.avg.turnover_rate[props.year])
          * (calcs.you.total_number_of_employees[props.year]
            * ((calcs.you.revenue_per_employee[props.year] * lostProductivity * lostProductivityTime)
              + (calcs.you.average_wages_and_salaries[props.year] * lostWagesTime)
              + ((calcs.you.training[props.year] * .25) / calcs.you.total_number_of_employees[props.year])
              + (calcs.you.revenue_per_employee[props.year] * employeeProductivityDecline * employeeProductivityDeclineTime))));
      } else {
        return 0;
      };
    }

    return 0;
  }

  const customMultipleCharts = (chartProps) => {
    let pdf = chartProps.pdf
    let reportPeriod = chartProps.key === 'versus' ? 'quarter' : 'month';

    if (props.quarterMonths) {
      let reportLabel, endMonth; 
      const reduceMs = reportPeriod === 'quarter' ? props.quarterMonths[1] : [endMonthOfSelectedYear];
      
      if (props?.tabFilters?.date_through_monthly_month && props?.tabFilters?.date_through_monthly_year) {
        endMonth = endMonthOfSelectedYear;
      } else {
        endMonth = Math.max(...props.quarterMonths[1]);
        endMonth = endMonthOfSelectedYear > endMonth ? endMonthOfSelectedYear : endMonth;
      }
      const ytdMonths = Array.from({ length: endMonth }, (_, i) => i + 1);

      if (reportPeriod === 'quarter') {
        if (props?.tabFilters?.date_through_monthly_month && props?.tabFilters?.date_through_monthly_year) {
          let monthIndex = endMonthOfSelectedYear - 1;
          reportLabel = `${props.quarterMonths[0]}, Date Through: ${monthsList[monthIndex]}`;
        } else {
          reportLabel = props.quarterMonths[0];
        }
      } else if (reportPeriod === 'month') {
        let monthIndex = endMonthOfSelectedYear - 1
        reportLabel = monthsList[monthIndex];
      }

      const tableRows = [
        {
          copy: 'Revenue',
          key: 'total_revenue',
          style: {
            fontWeight: 'bold'
          },
          var: true,
          valueFormat: 'money',
          color1: true
        },
        {
          copy: 'COGS',
          key: 'total_costs',
          var: true,
          valueFormat: 'money'
        },
        {
          copy: 'Gross Profit',
          key: 'gross_profit',
          style: {
            fontWeight: 'bold'
          },
          var: true,
          valueFormat: 'money',
          color1: true
        },
        {
          copy: 'GM %',
          key: 'gross_profit_margin',
          realKey: 'gross_profit',
          percentOfRevenue: true,
          style: {
            fontStyle: 'italic'
          },
          padding: '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0',
          var: false,
          valueFormat: 'percent'
        },
        {
          copy: 'OpEx',
          key: 'total_operating_expenses',
          var: true,
          valueFormat: 'money'
          // style: {
          //   fontStyle: 'italic'
          // }
        },
        {
          copy: 'Op Profit',
          key: 'operating_profit',
          style: {
            fontWeight: 'bold'
          },
          var: true,
          valueFormat: 'money',
          color1: true
        },
        {
          copy: 'OM %',
          key: 'operating_profit_margin',
          realKey: 'operating_profit',
          percentOfRevenue: true,
          style: {
            fontStyle: 'italic'
          },
          padding: '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0',
          var: false,
          valueFormat: 'percent'
        },
        {
          copy: 'Other (Inc)/E',
          key: 'total_other_costs',
          var: true,
          valueFormat: 'money'
        },
        {
          copy: 'Net Profit',
          key: 'operating_expenses_net_income',
          style: {
            fontWeight: 'bold'
          },
          var: true,
          valueFormat: 'money',
          color2: true
        },
        {
          copy: 'NM %',
          key: 'operating_expenses_net_income_margin',
          realKey: 'operating_expenses_net_income',
          percentOfRevenue: true,
          style: {
            fontStyle: 'italic'
          },
          padding: '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0',
          var: false,
          valueFormat: 'percent'
        }
      ]
      let thisYear = monthlyCalcs.you || {}
      let lastYear = monthlyCalcs.you || {}

      // This Year & Actual are the same
      let forecastVals = props.forecastVals
      let forecastRevenue = forecastVals?.['total_revenue'];
      let forecastYear = forecastRevenue ? Object.keys(forecastRevenue)[0] : 0
      let dataForRows = {}

      tableRows.map(row => {
        if (row.percentOfRevenue) {
          dataForRows[row.key] = {
            'thisYear': {},
            'lastYear': {},
            'forecastVals': {
              'QorM': 0,
              'Year to Date': 0,
              'Full Year': 0
            }
          }
          dataForRows[row.key]['thisYear']['QorM'] = dataForRows[row.realKey]['thisYear']['QorM'] / dataForRows['total_revenue']['thisYear']['QorM']
          dataForRows[row.key]['thisYear']['Year to Date'] = dataForRows[row.realKey]['thisYear']['Year to Date'] / dataForRows['total_revenue']['thisYear']['Year to Date']
          dataForRows[row.key]['lastYear']['QorM'] = dataForRows[row.realKey]['lastYear']['QorM'] / dataForRows['total_revenue']['lastYear']['QorM']
          dataForRows[row.key]['lastYear']['Year to Date'] = dataForRows[row.realKey]['lastYear']['Year to Date'] / dataForRows['total_revenue']['lastYear']['Year to Date']
          dataForRows[row.key]['lastYear']['Full Year'] = dataForRows[row.realKey]['lastYear']['Full Year'] / dataForRows['total_revenue']['lastYear']['Full Year']
          dataForRows[row.key]['forecastVals']['QorM'] = dataForRows[row.realKey]['forecastVals']['QorM'] / dataForRows['total_revenue']['forecastVals']['QorM']
          dataForRows[row.key]['forecastVals']['Year to Date'] = dataForRows[row.realKey]['forecastVals']['Year to Date'] / dataForRows['total_revenue']['forecastVals']['Year to Date']
          dataForRows[row.key]['forecastVals']['Full Year'] = dataForRows[row.realKey]['forecastVals']['Full Year'] / dataForRows['total_revenue']['forecastVals']['Full Year']
        } else {
          dataForRows[row.key] = {
            'thisYear': {},
            'lastYear': {},
            'forecastVals': {}
          }
          dataForRows[row.key]['thisYear']['QorM'] = reduceMs.reduce((sum, month) => {
            return sum + (thisYear?.[row.key]?.[selectedYear]?.[month] || 0);
          }, 0);
          dataForRows[row.key]['thisYear']['Year to Date'] = ytdMonths.reduce((sum, month) => {
            return sum + (thisYear?.[row.key]?.[selectedYear]?.[month] || 0);
          }, 0);

          dataForRows[row.key]['lastYear']['QorM'] = reduceMs.reduce((sum, month) => {
            return sum + (lastYear?.[row.key]?.[previousYear]?.[month] || 0);
          }, 0);
          dataForRows[row.key]['lastYear']['Year to Date'] = ytdMonths.reduce((sum, month) => {
            return sum + (lastYear?.[row.key]?.[previousYear]?.[month] || 0);
          }, 0);
          dataForRows[row.key]['lastYear']['Full Year'] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce((sum, month) => {
            return sum + (lastYear?.[row.key]?.[previousYear]?.[month] || 0);
          }, 0);

          if (forecastVals?.[row.key]) {
            dataForRows[row.key]['forecastVals']['QorM'] = reduceMs.reduce((sum, month) => {
              return sum + (forecastVals?.[row.key]?.[forecastYear]?.[month] || 0);
            }, 0);
            dataForRows[row.key]['forecastVals']['Year to Date'] = ytdMonths.reduce((sum, month) => {
              return sum + (forecastVals?.[row.key]?.[forecastYear]?.[month] || 0);
            }, 0);
            dataForRows[row.key]['forecastVals']['Full Year'] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce((sum, month) => {
              return sum + (forecastVals?.[row.key]?.[forecastYear]?.[month] || 0);
            }, 0);
          } else {
            dataForRows[row.key]['forecastVals']['QorM'] = 0
            dataForRows[row.key]['forecastVals']['Year to Date'] = 0
            dataForRows[row.key]['forecastVals']['Full Year'] = 0
          }
        }
      })

      const ReportPeriodTable = (props) => {
        let tableTitle = props.label;

        return (
          <table className={pdf ? 'report-period-table-pdf' : 'report-period-table'} style={props.tableStyle}>
            <thead>
              <tr>
                {props.firstTable && <th style={{ 'borderBottom': '1px solid #000000' }}></th>}
                <th className='report-period-title' style={{ 'borderBottom': '1px solid #000000' }} colSpan={3}>{tableTitle}</th>
              </tr>
              <tr>
                {props.firstTable && <th style={{ 'borderBottom': '1px solid #000000' }}></th>}
                <th className='report-period-title' style={{ 'borderBottom': '1px solid #000000' }}>{props.columns[0]}</th>
                <th className='report-period-title' style={{ 'borderBottom': '1px solid #000000' }}>{props.columns[1]}</th>
                <th className='report-period-title' style={{ 'borderBottom': '1px solid #000000' }}>{props.columns[2]}</th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map(row => {
                const cellStyle = row.style ? { ...row.style } : {}
                let cellClassName = ''
                if (row.color1) {
                  cellClassName = props.colors[0]
                }
                if (row.color2) {
                  cellClassName = props.colors[1]
                }

                let col1 = props.columns[0] === 'This Year' || props.columns[0] === 'Actual' ? 'thisYear' : props.columns[0] === 'Last Year' ? 'lastYear' : 'forecastVals';
                let col2 = props.columns[1] === 'This Year' || props.columns[1] === 'Actual' ? 'thisYear' : props.columns[1] === 'Last Year' ? 'lastYear' : 'forecastVals';

                let firstVal = dataForRows[row.key][col1][props.extractKey]
                let secondVal = dataForRows[row.key][col2][props.extractKey]

                return (
                  <tr key={row.copy}>
                    {props.firstTable && <td className={cellClassName} style={cellStyle}>{row.copy}</td>}
                    <td className={`number-val ${cellClassName}`} style={cellStyle}>{row.valueFormat === 'money' ? parseMoney(firstVal) : Math.round(firstVal * 100) + '%'}</td>
                    <td className={`number-val ${cellClassName}`} style={cellStyle}>{row.valueFormat === 'money' ? parseMoney(secondVal) : Math.round(secondVal * 100) + '%'}</td>
                    <td className={`number-val ${cellClassName}`} style={cellStyle}>{row.var ? parseMoney(firstVal - secondVal) : ''}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )
      }

      const VSTable = (props) => {
        return (
          <div className='vs-table'>
            <div className={pdf ? `vs-title-pdf ${props.colors[0]}` : `vs-title ${props.colors[0]}`} style={{ 'borderBottom': '1px solid #000000', 'padding': '3px' }}>{props.title}</div>
            <div className='report-period-table-container'>
              {props.periods.map((p, i) => {
                let tableStyle = {}
                if (i > 0) {
                  tableStyle['borderLeft'] = '1px solid #000000'
                }
                return (
                  <ReportPeriodTable key={p.key} firstTable={p.firstTable} tableStyle={tableStyle} extractKey={p.extractKey} label={p.label} columns={p.columns} colors={props.colors} />
                )
              })}
            </div>
          </div>
        )
      }

      let forecastNameShortened = props.forecastName && props.forecastName.length > 12 ? props.forecastName.slice(0, 12) + '...' : props.forecastName || '';

      return (
        <div className={pdf ? 'custom-multiple-tables-pdf' : 'custom-multiple-tables'}>
          <VSTable
            key={'vs-table-1'}
            title='This Year vs. Last Year'
            periods={[
              { key: 'table-1', extractKey: 'QorM', label: reportLabel, firstTable: true, columns: ['This Year', 'Last Year', 'Var'] },
              { key: 'table-2', extractKey: 'Year to Date', label: 'Year to Date', columns: ['This Year', 'Last Year', 'Var'] }
            ]}
            colors={['first-table-color-one', 'first-table-color-two']}
          />
          <VSTable
            key={'vs-table-2'}
            firstTable={false}
            title={`Actual vs. Forecast: ${props.forecastName}`}
            periods={[
              { key: 'table-3', extractKey: 'QorM', label: reportLabel, columns: ['Actual', 'Forecast', 'Var'] },
              { key: 'table-4', extractKey: 'Year to Date', label: 'Year to Date', columns: ['Actual', 'Forecast', 'Var'] },
            ]}
            colors={['second-table-color-one', 'second-table-color-two']}
          />
          <VSTable
            key={'vs-table-3'}
            firstTable={false}
            title={`Forecast: ${forecastNameShortened} vs. Last Year`}
            periods={[
              { key: 'table-5', extractKey: 'Full Year', label: 'Full Year', columns: ['Forecast', 'Last Year', 'Var'] },
            ]}
            colors={['third-table-color-one', 'third-table-color-two']}
          />
        </div>
      )
    } else {
      return (
        <div className={pdf ? 'custom-multiple-tables-pdf' : 'custom-multiple-tables'}>
          Must have Monthly Data to display this chart, Executive Dashboard.
        </div>
      )
    }
  }

  const buildRankingTable = (positionStyles, chartProps, rankingInfo) => {
    let top10 = rankingInfo[chartProps.metricKey].slice(0, 10);
    let cellLength = chartProps.keys.length;
    return (
      <div className='snapshot-table' key={chartProps.key} style={props.pdf ? { minWidth: chartProps.widthPx, minHeight: chartProps.heightPx, width: chartProps.widthPx, height: chartProps.heightPx, ...positionStyles } : {}}>
        <table>
          <thead>
            <tr>
              <th className='snapshot-title snap-cell' colSpan={cellLength}>{chartProps.title}</th>
            </tr>
            <tr className='snapshot-header-cols'>
              {
                (chartProps.headerCols.map((h) => {
                  return <th key={`${chartProps.title}-${h}`}><div className='snap-cell'><p>{h}</p></div></th>
                }))
              }
            </tr>
          </thead>
          <tbody>
            {
              (top10.map((s, i) => {
                let rowColor = i % 2 === 0 ? { backgroundColor: '#F5F5F5' } : {}
                return (
                  <tr key={`${chartProps.key}-row-${i}`} style={rowColor}>
                    {chartProps.keys.map((k) => {
                      if (Array.isArray(k)) {
                        let key = k[0]
                        return <td key={`snap-cell-${k}`}><div className='snap-cell'><p>{format(k[1], s[key])}</p></div></td>
                      } else {
                        return <td key={`snap-cell-${k}`}><div className='snap-cell'><p>{s[k]}</p></div></td>
                      }
                    })}
                  </tr>
                )
              }))
            }
          </tbody>
        </table>
      </div>
    )
  }

  const MyNotes = () => {
    const [myNotesSection, setMyNotesSection] = useState({ userNotes: '' || props.myNotes.userNotes })
    const [timer, setTimer] = useState(null)
    const [count, setCount] = useState(0);

    const handleNewNotes = (newNotes) => {
      setMyNotesSection(() => {
        return { userNotes: newNotes }
      })

      clearTimeout(timer)
      const newTimer = setTimeout(() => {
        props.handleMoneyNotes(newNotes);
      }, 3000)
      setTimer(newTimer)
    }

    return (
      <>
        <h3 style={{ 'margin': 0, 'textAlign': 'center' }}>Notes</h3>
        {props.pdf
          ? <div className='my-notes-dashboard'>{myNotesSection.userNotes}</div>
          : <textarea className='my-notes-dashboard' value={myNotesSection.userNotes} onChange={(e) => handleNewNotes(e.target.value)} />
        }
      </>
    )
  }

  const MetricNotes = ({ noteProps }) => {
    const [metricNotes, setMetricNotes] = useState('' || noteProps.metricRow.notes)
    const [timer, setTimer] = useState(null)
    const [count, setCount] = useState(0);

    const handleNewNotes = (newNotes) => {
      let notes = newNotes.length >= 1100 ? newNotes.substring(0, 1100) : newNotes;
      setMetricNotes(notes)

      clearTimeout(timer)
      const newTimer = setTimeout(() => {
        props.handleMetricNotes(noteProps.metricRow.relatedCheckedKey, newNotes)
      }, 3000)
      setTimer(newTimer)
    }

    let noteTitle = `${noteProps.metricRow.copy} Notes` || 'Notes'

    return (
      <>
        <h3 style={{ 'color': '#000000', 'fontSize': '18px', 'fontWeight': 'normal', 'margin': '5px', 'textAlign': 'center' }}>{noteTitle}</h3>
        {props.pdf
          ? <div className='my-notes-dashboard'>{metricNotes}</div>
          : <textarea className='my-notes-dashboard' value={metricNotes} onChange={(e) => handleNewNotes(e.target.value)} />
        }
      </>
    )
  }

  const buildFocusedClients = () => {
    const hrefBuilder = (subdomain, path) => {
      const domainSplit = document.location.host.split(".");
      domainSplit[0] = subdomain;
      return location.protocol + "//" + domainSplit.join(".") + path;
    }
    const buildBody = () => {
      if (props.clientData && props.clientData.length > 0) {
        return props.clientData.map((client, i) => {
          let rowColor = {}
          i % 2 === 0 ? rowColor = { backgroundColor: '#F5F5F5' } : {}
          return (
            <div key={Math.random(89)} className='practice-focused-clients-row'>
              <div className='focused-client-cell'><p>Client: {client.name ? client.name : ''}</p></div>
              {client.report_status === 'available'
                ? <div className='focused-client-cell'><p>Report: <a className='hide-on-print' href={hrefBuilder(client.subdomain, "/reports/money")} target='_blank'><i className="fa fa-bar-chart" aria-hidden="true"></i></a></p></div>
                : <div className='focused-client-cell'><p>Report: <a className='hide-on-print' href={'/unlock_reports/' + client.company_id} target='_blank'><i className="fa fa-lock" aria-hidden="true"></i></a></p></div>}
              <div className='focused-client-cell'><p>NAICS: {client.naics ? client.naics : ''}</p></div>
              <div className='focused-client-cell'><p>Partner: {client.partners}</p></div>
              <div className='focused-client-cell'><p>Status: {client.status}</p></div>
            </div>
          )
        })
      } else {
        return <p>Select clients you would like to focus on in <b>Focus column</b> over in the <b>Client Analysis</b> tab.</p>
      }
    }
    return (
      <div key='practice_focused_clients' className='practice-focused-clients-item'>
        <div><h3 className='practice-focused-clients-title'>Your Focused Clients: {props.clientData.length}</h3></div>
        <div className='practice-focused-clients-container'>
          {buildBody()}
        </div>
      </div>
    )
  }

  const getPrintPositionStyles = (item) => {
    const printStyles = { position: 'absolute', backgroundColor: 'white', border: '1px solid rgba(67, 71, 85, 0.27)', borderBottom: '1px solid rgba(90, 125, 188, 0.2)', borderRadius: '15px' }
    let width = item.w > 1 ? (item.w * 34) + (item.w - 1) : item.w * 34
    let setHeightNum = item.h > 6 ? 6 : item.h
    let height = setHeightNum > 1 ? (setHeightNum * 34) + (setHeightNum - 1) : setHeightNum * 34
    let posX = (item.x * 34) + ((item.x + 1) * 1)
    let posY = (item.y * 34) + ((item.y + 1) * 1)

    printStyles.width = `${width}mm`
    printStyles.height = `${height}mm`
    printStyles.left = `${posX}mm`
    printStyles.top = `${posY}mm`
    return printStyles
  }


  const resizeChildLayout = (childLayoutWithData, childLayoutForDash = null) => {
    // How to make sure Parent is tall and wide enough for children so they don't look squished.
    // layout children have h, w, x, y
    let parentH = childLayoutForDash.h
    let childLayout = childLayoutWithData?.layout || []

    const maxY = Math.max(
      ...childLayout.map(c => {
        const y = Number.isFinite(c.y) ? c.y : 0;
        const h = Number.isFinite(c.h) ? c.h : 0;
        return y + h;
      })
    );

    if ((maxY) > parentH) {
      childLayoutForDash.h = maxY
    }

    return childLayoutForDash;
  }

  // react-grid-layout recommends memoizing items in layout to optimize rendering
  let layoutItems = useMemo(() => {
    return props.dashboardLayout.map((l) => {
      let positionStyles = props.pdf ? getPrintPositionStyles(l) : {}
      if (props.page === 'money' && l.i === 'my_notes') {
        return (<div key='my_notes' style={positionStyles}>
          {props.pdf ? null : <button className='no-drag lock-btn' onClick={() => props.handleToggleDraggable('my_notes', 'moneyDashboard')}>{l.isDraggable ? <FontAwesomeIcon icon={faLockOpen} /> : <FontAwesomeIcon icon={faLock} />}</button>}
          <MyNotes />
        </div>)
      } else if ((props.page === 'money' && l.i.includes('_bar_chart')) || (props.page === 'money' && l.i.includes('_chart')) || (props.page === 'people' && l.i.includes('chart')) || (props.page === 'customers' && l.i.includes('chart'))) {
        let parentMetric = l['metricRow'];
        let chartKey = l.key
        let styles = l['metricRow'] ? l['metricRow']['styles'] : l['styles'] ? l['styles'] : {};
        let youData, compareData, chartOptions;
        let page = props.page
        if (page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) {
          page = 'people'
        } else if (page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) {
          page = 'customers'
        }

        let chartProps = {
          i: l.i,
          chartType: 'editableChart',
          aggregateYTDDate: props.aggregateYTDDate || null,
          companyYTDDate: props.companyYTDDate || null,
          format: !['kfis', 'people_financial_detail', 'customers_financial_detail', 'people_kpi', 'customers_kpi'].includes(parentMetric.sheet) && props.displayColumnsBy === 'Months' ? 'money' : parentMetric.format,
          compareWith: props.compareWith || null,
          compareWithTitle: props.monthlyCompareWithTitle || null,
          displayColumnsBy: props.displayColumnsBy || null,
          fiscalYearEnd: props.fiscalYearEnd || '12/31',
          key: parentMetric.key,
          months: props.monthLabels || null,
          onManyReports: parentMetric ? parentMetric['onManyReports'] : false,
          page: page,
          pdf: props.pdf,
          reportPeriod: props.reportPeriod,
          styles: styles || { seriesOne: { type: 'column' }, seriesTwo: { type: 'column' } },
          title: titleSetter(parentMetric),
          years: (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') ? [props.year - 1, props.year] : props.yearRange,
        }

        if (['pnl', 'balance_sheet', 'people_financial_detail', 'customers_financial_detail', 'people_kpi', 'customers_kpi'].includes(parentMetric.sheet)) {
          youData = buildYouLineOrColData(chartProps, parentMetric.sheet);
          compareData = props.compareWith !== 'None' && props.compareWith !== 'Default:None' ? buildCompareLineOrColData(chartProps, parentMetric.sheet) : null;
        }

        if (parentMetric.sheet === 'cash_flow') {
          if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            let cashValues = AnnualCashFlowValues(calcs, avgAnnualCalcs, props.calcsAvgType, props.yearRange, parentMetric.key)
            youData = []
            compareData = []
            props.yearRange.forEach(year => {
              const youVal = cashValues['you' + year];
              const avgVal = cashValues['avg' + year];
              youData.push(typeof youVal !== 'undefined' ? youVal : null);
              if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
                compareData.push(typeof avgVal !== 'undefined' ? avgVal : null);
              }
            })
          }

          if (props.displayColumnsBy === 'Months') {
            youData = []
            compareData = []
            let year1 = selectedYear;
            let year2 = previousYear;
            let year3 = null;
            let year4 = null;
            const calcsYou = monthlyCalcs.you;
            const previousYearCalcsYou = monthlyCalcs.you;
            let compareVals = null;
            let prevYearCompareVals = null;
            let isForecast = false
            if (props.compareWith === 'Peers' || props.compareWith === 'Default:Peers') {
              compareVals = avgMonthlyCalcs.avg;
              prevYearCompareVals = avgMonthlyCalcs.avg;
              year3 = selectedYear
              year4 = previousYear
            }
            if (props.compareWith === 'YOY' || props.compareWith === 'Default:YOY') {
              compareVals = monthlyCalcs.you;
              prevYearCompareVals = monthlyCalcs.you;
              year3 = previousYear
              year4 = twoYearsAgo
            }
            if (props.compareWith && props.compareWith.includes('Forecast')) {
              isForecast = true
              let forecastRevenue = props.forecastVals?.['total_revenue'];
              let compareSelectedYear = forecastRevenue ? Object.keys(forecastRevenue)[0] : null
              compareVals = props.forecastVals
              prevYearCompareVals = monthlyCalcs.you;
              year3 = compareSelectedYear
              year4 = previousYear
            }
            let { youValues, compareValues } = MonthlyCashFlowValues(parentMetric.key, calcsYou, year1, year2, compareVals, year3, year4, isForecast)
            Object.values(youValues).slice(0, endMonthOfSelectedYear).forEach(yv => {
              youData.push(yv)
            })
            if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
              Object.values(compareValues).slice(0, endMonthOfSelectedYear).forEach(cv => {
                compareData.push(cv)
              })
            }
          }

          if (props.reportPeriod === 'Year to Date') {
            function commonSizeValue(props) {
              return props.totalRevenue ? (props.value / props.totalRevenue) : 0
            }

            const youSelectedYearTotalRevenue = monthlyCalcs?.you?.total_revenue?.[selectedYear];
            const youPreviousYearTotalRevenue = monthlyCalcs?.you?.total_revenue?.[previousYear];
            const youSelectedYearYTDRevMonths = getYTDMonths(youSelectedYearTotalRevenue, ytd_months);
            const youPreviousYearYTDRevMonths = getYTDMonths(youPreviousYearTotalRevenue, ytd_months);
            const youSelectedYearYTDRevenue = Object.values(youSelectedYearYTDRevMonths).reduce((a, b) => a + b, 0)
            const youPreviousYearYTDRevenue = Object.values(youPreviousYearYTDRevMonths).reduce((a, b) => a + b, 0)
            const compareSelectedYearTotalRevenue = avgMonthlyCalcs?.avg?.total_revenue?.[selectedYear];
            const comparePreviousYearTotalRevenue = avgMonthlyCalcs?.avg?.total_revenue?.[previousYear];
            const compareSelectedYearYTDRevMonths = getYTDMonths(compareSelectedYearTotalRevenue, ytd_months);
            const comparePreviousYearYTDRevMonths = getYTDMonths(comparePreviousYearTotalRevenue, ytd_months);
            const compareSelectedYearYTDRevenue = Object.values(compareSelectedYearYTDRevMonths).reduce((a, b) => a + b, 0)
            const comparePreviousYearYTDRevenue = Object.values(comparePreviousYearYTDRevMonths).reduce((a, b) => a + b, 0)

            let newerYearVals = YTDCashFlowValues(parentMetric.key, monthlyCalcs, avgMonthlyCalcs, props.year, props.year - 1, ytd_months);
            let youSelectedYearVal = newerYearVals['youValue'];
            let compareSelectedYearVal = newerYearVals['compareValue'];

            let olderYearVals = YTDCashFlowValues(parentMetric.key, monthlyCalcs, avgMonthlyCalcs, props.year - 1, props.year - 2, ytd_months);
            let youPreviousYearVal = olderYearVals['youValue'];
            let comparePreviousYearVal = olderYearVals['compareValue'];

            let valuePYMonthlyCommonSize = commonSizeValue({ year: props.year - 1, value: youPreviousYearVal, totalRevenue: youPreviousYearYTDRevenue })
            let valuePYPeersMonthlyCommonSize = props.compareWith === 'Peers' ? commonSizeValue({ year: props.year - 1, value: comparePreviousYearVal, totalRevenue: comparePreviousYearYTDRevenue }) : null;
            let valueCYMonthlyCommonSize = commonSizeValue({ year: props.year, value: youSelectedYearVal, totalRevenue: youSelectedYearYTDRevenue })
            let valueCYPeersMonthlyCommonSize = props.compareWith === 'Peers' ? commonSizeValue({ year: props.year, value: compareSelectedYearVal, totalRevenue: compareSelectedYearYTDRevenue }) : null;

            youData = [valuePYMonthlyCommonSize, valueCYMonthlyCommonSize]
            compareData = props.compareWith === 'Peers' ? [valuePYPeersMonthlyCommonSize, valueCYPeersMonthlyCommonSize] : null
          }
        }

        if (parentMetric.sheet === 'kfis') {
          if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            let kfisValues = AnnualKFIsValues(calcs, avgAnnualCalcs, props.calcsAvgType, props.yearRange, parentMetric.key)
            youData = []
            compareData = []
            props.yearRange.forEach(year => {
              youData.push(typeof kfisValues[year] !== 'undefined' ? kfisValues[year] : null)
              if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
                compareData.push(
                  typeof kfisValues['avg' + year] !== 'undefined' ? kfisValues['avg' + year] : null
                )
              }
            })
          }

          if (props.displayColumnsBy === 'Months') {
            let isForecast = props.compareWith && props.compareWith.includes('Forecast')
            youData = []
            compareData = []
            let numberOfMonths = 0
            let useableMonths = monthlyCalcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthlyCalcs?.['you']?.['cash']?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
            useableMonths.forEach(thing => thing !== null ? numberOfMonths += 1 : null)
            let { youValues, compareValues } = MonthlyKFIsValues(parentMetric, numberOfMonths, props.compareWith, selectedYear, previousYear, twoYearsAgo, monthlyCalcs.you, avgMonthlyCalcs.avg, isForecast, props.forecastVals)
            Object.values(youValues).forEach(yv => {
              youData.push(yv)
            })
            if (props.compareWith !== 'None' && props.compareWith !== 'Default:None') {
              Object.values(compareValues).forEach(cv => {
                compareData.push(cv)
              })
            }
          }

          if (props.reportPeriod === 'Year to Date') {
            youData = []
            compareData = []
            chartProps.years.forEach(year => {
              let youMetric = calculateKFIMetric(parentMetric.key, monthlyCalcs.you, year, year - 1, ytd_months);
              youData.push(youMetric)
              if (props.compareWith === 'Peers') {
                let peersMetric = calculateKFIMetric(parentMetric.key, avgMonthlyCalcs.avg, year, year - 1, ytd_months);
                compareData.push(peersMetric)
              }
            })
          }
        }
        chartOptions = getLineOrColOptions(chartProps, youData, compareData, props.fiscalYearEnd);
        return (
          <div key={l.i} style={positionStyles}>
            <button className='no-drag edit-dash-item-btn' onClick={() => props.handleEditChartModal('open', chartProps, chartOptions)}><FontAwesomeIcon icon={faPencil} /></button>
            <HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: l.i, id: l.i }} highcharts={Highcharts} options={chartOptions} />
          </div>
        )
      } else if (l.i.includes('impact_box')) {
        let parentMetric = l['metricRow'];
        let finalCopy = parentMetric.copy;
        let boxStyle = {
          'backgroundColor': 'white',
          'display': 'flex',
          'flexDirection': 'column',
          'justifyContent': 'space-evenly',
          'alignItems': 'center',
          'height': '100%',
          'width': '100%',
          'textAlign': 'center'
        }
        let statusTextColor = {
          'fontSize': '24px',
          'fontWeight': 'bold',
        }
        let allStyles = { ...boxStyle, ...positionStyles }
        statusTextColor['fontSize'] = props.pdf ? '18px' : '24px'
        let impactTextStyle = props.pdf ? { fontSize: '0.7em', padding: '0 2px' } : { fontSize: '15px', padding: '0 2px' }
        if (l.i.includes('labor_cogs')) {
          finalCopy = `Labor COGS - ${parentMetric.copy}`
        }

        if (props.compareWith === 'None' || props.compareWith === 'Default:None') {
          return (
            <div key={l.i} className='impact-square' style={allStyles}>
              <div style={{ marginBottom: '5px' }}>
                <div style={impactTextStyle}>{`${finalCopy} Impact Box`}</div>
              </div>
              <div>
                <div style={impactTextStyle}>Compare with None Selected</div>
              </div>
            </div>
          )
        } else {
          let realCalcs = calcs
          let aggregateCalcs = avgAnnualCalcs
          if (props.displayColumnsBy === 'Months' || props.reportPeriod === 'Year to Date') {
            realCalcs = monthlyCalcs
            aggregateCalcs = avgMonthlyCalcs
          }

          let { copy, impactText, status, deltaCommonSize, impactValueFormatted } = buildImpactBox(parentMetric, parentMetric['sheet'], props.displayColumnsBy, props.reportPeriod, props.compareWith, props.year, props.yearRange, ytd_months, endMonthOfSelectedYear, realCalcs, aggregateCalcs, props.calcsAvgType, props.monthlyCompareWithTitle, props.forecastVals, selectedYear, previousYear, twoYearsAgo, threeYearsAgo)
          if (!impactText) {
            impactText = noSpecificTextMaker(finalCopy, status, impactValueFormatted, deltaCommonSize, props.compareWith, props.monthlyCompareWithTitle)
          }
          let impactTextClass = impactBoxStatusColor(status)

          if (impactText) {
            return (
              <div key={l.i} className='impact-square' style={allStyles}>
                <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                  <span className={impactTextClass} style={statusTextColor}>{deltaCommonSize}</span>
                  <div style={impactTextStyle}>{impactText['text1']}</div>
                </div>
                <div style={{ fontWeight: 'bold' }}>
                  <span className={impactTextClass} style={statusTextColor}>{impactValueFormatted}</span>
                  <div style={impactTextStyle}>{impactText['textNotesSection']}</div>
                </div>
              </div>
            )
          }
        }
      } else if (l.i.includes('notes')) {
        return (
          <div key={l.i} style={positionStyles}>
            {props.pdf ? null : <button className='no-drag lock-btn' onClick={() => props.handleToggleDraggable(l.i, 'moneyDashboard')}>{l.isDraggable ? <FontAwesomeIcon icon={faLockOpen} /> : <FontAwesomeIcon icon={faLock} />}</button>}
            <MetricNotes noteProps={l} />
          </div>
        )
      } else if (l.i === 'current_month_revenue') {
        let thisYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear]
        let prevYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear - 1]
        positionStyles['display'] = 'flex'
        positionStyles['flexDirection'] = 'column'
        positionStyles['justifyContent'] = 'center'
        positionStyles['alignItems'] = 'center'

        return (
          <div key={l.i} style={positionStyles}>
            <div className='analysis-value-dashboard-container'>
              {revenueDisplay(props.pdf, thisYearRevnue, prevYearRevnue, 'currentMonth', selectedYear)}
            </div>
          </div>
        )
      } else if (l.i === 'last_month_revenue') {
        let thisYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear]
        let prevYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear - 1]
        positionStyles['display'] = 'flex'
        positionStyles['flexDirection'] = 'column'
        positionStyles['justifyContent'] = 'center'
        positionStyles['alignItems'] = 'center'

        return (
          <div key={l.i} style={positionStyles}>
            <div className='analysis-value-dashboard-container'>
              {revenueDisplay(props.pdf, thisYearRevnue, prevYearRevnue, 'lastMonth', selectedYear)}
            </div>
          </div>
        )
      } else if (l.i === 'ytd_month_revenue') {
        let thisYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear]
        let prevYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear - 1]
        positionStyles['display'] = 'flex'
        positionStyles['flexDirection'] = 'column'
        positionStyles['justifyContent'] = 'center'
        positionStyles['alignItems'] = 'center'

        return (
          <div key={l.i} style={positionStyles}>
            <div className='analysis-value-dashboard-container'>
              {revenueDisplay(props.pdf, thisYearRevnue, prevYearRevnue, 'ytd', selectedYear)}
            </div>
          </div>
        )
      } else if (l.i === 'revenue_top_10_accounts') {
        let title = l?.metricRow?.copy || 'Revenue Mix - Top 10 Accounts This Year'
        let thisYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear] ? Object.values(monthly_calcs?.you?.total_revenue?.[selectedYear]) : []
        return (
          <div key={l.i} style={positionStyles}>
            {revenueTop10Chart(props.pdf, thisYearRevnue, monthly_calcs, selectedYear, props.naicsCode, title)}
          </div>
        )
      } else if (l.i === 'revenue_monthly_cummulative') {
        let chartProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' } }
        let chartValues = monthly_calcs?.you?.['total_revenue']?.[selectedYear] ? Object.values(monthly_calcs?.you?.['total_revenue']?.[selectedYear]) : []
        return (
          <div key={l.i} style={positionStyles}>
            <HighchartsReact highcharts={Highcharts} containerProps={chartProps} options={revAndOpexAreaChartOptions(props.pdf, 'total_revenue', chartValues, selectedYear)} />
          </div>
        )
      } else if (l.i === 'revenue_monthly_compare') {
        let chartProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' } }
        let thisYear = monthly_calcs?.you?.['total_revenue']?.[selectedYear] ? Object.values(monthly_calcs?.you?.['total_revenue']?.[selectedYear]) : []
        let prevYear = monthly_calcs?.you?.['total_revenue']?.[selectedYear - 1] ? Object.values(monthly_calcs?.you?.['total_revenue']?.[selectedYear - 1]) : []
        let peersThisYear = props.aggregateData?.monthly?.avg?.['total_revenue']?.[selectedYear] ? Object.values(props.aggregateData?.monthly?.avg?.['total_revenue']?.[selectedYear]) : []
        const forecastYear = Object.keys(props.forecastVals || {}).length > 0 ? Object.keys(props.forecastVals['total_revenue'])[0] : null
        let forecast = props.forecastVals?.['total_revenue']?.[forecastYear] ? Object.values(props.forecastVals?.['total_revenue']?.[forecastYear]) : []
        return (
          <div key={l.i} style={positionStyles}>
            <HighchartsReact highcharts={Highcharts} containerProps={chartProps} options={revAndOpexLineChartOptions(props.pdf, 'total_revenue', thisYear, prevYear, peersThisYear, forecast, props.forecastName, selectedYear)} />
          </div>
        )
      } else if (l.i === 'current_month_opex') {
        let thisYearOpex = monthly_calcs?.you?.total_operating_expenses?.[selectedYear]
        let prevYearOpex = monthly_calcs?.you?.total_operating_expenses?.[selectedYear - 1]
        positionStyles['display'] = 'flex'
        positionStyles['flexDirection'] = 'column'
        positionStyles['justifyContent'] = 'center'
        positionStyles['alignItems'] = 'center'

        return (
          <div key={l.i} style={positionStyles}>
            <div className='analysis-value-dashboard-container'>
              {expensesDisplay(props.pdf, thisYearOpex, prevYearOpex, 'currentMonth', selectedYear)}
            </div>
          </div>
        )
      } else if (l.i === 'last_month_opex') {
        let thisYearOpex = monthly_calcs?.you?.total_operating_expenses?.[selectedYear]
        let prevYearOpex = monthly_calcs?.you?.total_operating_expenses?.[selectedYear - 1]
        positionStyles['display'] = 'flex'
        positionStyles['flexDirection'] = 'column'
        positionStyles['justifyContent'] = 'center'
        positionStyles['alignItems'] = 'center'

        return (
          <div key={l.i} style={positionStyles}>
            <div className='analysis-value-dashboard-container'>
              {expensesDisplay(props.pdf, thisYearOpex, prevYearOpex, 'lastMonth', selectedYear)}
            </div>
          </div>
        )
      } else if (l.i === 'ytd_month_opex') {
        let thisYearOpex = monthly_calcs?.you?.total_operating_expenses?.[selectedYear]
        let prevYearOpex = monthly_calcs?.you?.total_operating_expenses?.[selectedYear - 1]
        positionStyles['display'] = 'flex'
        positionStyles['flexDirection'] = 'column'
        positionStyles['justifyContent'] = 'center'
        positionStyles['alignItems'] = 'center'

        return (
          <div key={l.i} style={positionStyles}>
            <div className='analysis-value-dashboard-container'>
              {expensesDisplay(props.pdf, thisYearOpex, prevYearOpex, 'ytd', selectedYear)}
            </div>
          </div>
        )
      } else if (l.i === 'opex_top_10_accounts') {
        let title = l?.metricRow?.copy || 'Top 10 Expense Accounts This Year'
        let thisYearRevnue = monthly_calcs?.you?.total_revenue?.[selectedYear] ? Object.values(monthly_calcs?.you?.total_revenue?.[selectedYear]) : []
        return (
          <div key={l.i} style={positionStyles}>
            {expensesTop10Chart(props.pdf, thisYearRevnue, props.tree, monthly_calcs, selectedYear, title)}
          </div>
        )
      } else if (l.i === 'opex_monthly_cummulative') {
        let chartProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' } }
        let chartValues = monthly_calcs?.you?.['total_operating_expenses']?.[selectedYear] ? Object.values(monthly_calcs?.you?.['total_operating_expenses']?.[selectedYear]) : []
        return (
          <div key={l.i} style={positionStyles}>
            <HighchartsReact highcharts={Highcharts} containerProps={chartProps} options={revAndOpexAreaChartOptions(props.pdf, 'total_operating_expenses', chartValues, selectedYear)} />
          </div>
        )
      } else if (l.i === 'opex_monthly_compare') {
        let chartProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' } }
        let thisYear = monthly_calcs?.you?.['total_operating_expenses']?.[selectedYear] ? Object.values(monthly_calcs?.you?.['total_operating_expenses']?.[selectedYear]) : []
        let prevYear = monthly_calcs?.you?.['total_operating_expenses']?.[selectedYear - 1] ? Object.values(monthly_calcs?.you?.['total_operating_expenses']?.[selectedYear - 1]) : []
        let peersThisYear = props.aggregateData?.monthly?.avg?.['total_operating_expenses']?.[selectedYear] ? Object.values(props.aggregateData?.monthly?.avg?.['total_operating_expenses']?.[selectedYear]) : []
        const forecastYear = Object.keys(props.forecastVals || {}).length > 0 ? Object.keys(props.forecastVals['total_revenue'])[0] : null
        let forecast = props.forecastVals?.['total_operating_expenses']?.[forecastYear] ? Object.values(props.forecastVals?.['total_operating_expenses']?.[forecastYear]) : []
        return (
          <div key={l.i} style={positionStyles}>
            <HighchartsReact highcharts={Highcharts} containerProps={chartProps} options={revAndOpexLineChartOptions(props.pdf, 'total_operating_expenses', thisYear, prevYear, peersThisYear, forecast, props.forecastName, selectedYear)} />
          </div>
        )
      } else if (l.i === 'pnl_combo_view') {
        let allStyles = { ...positionStyles, display: 'flex' }
        let pnlComboProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' } }
        let chartCatergories = []

        if (props.displayColumnsBy === 'Years') {
          chartCatergories = props.yearRange
        } else if (props.displayColumnsBy === 'Months') {
          chartCatergories = props.monthLabels
        }

        let chartProps = {
          i: l.i,
          aggregateYTDDate: props.aggregateYTDDate || null,
          companyYTDDate: props.companyYTDDate || null,
          fiscalYearEnd: props.fiscalYearEnd || '12/31',
          months: props.monthLabels || null,
          pdf: props.pdf || false,
          reportPeriod: props.reportPeriod,
          categories: chartCatergories,
          years: (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') ? [props.year - 1, props.year] : props.yearRange,
        };
        let youData = [];
        let pnlKeysData = {
          total_revenue: {
            copy: 'Revenue',
            color: '#69B144'
          },
          total_costs: {
            copy: 'COGS',
            color: '#999999'
          },
          total_people_costs: {
            copy: 'People',
            color: '#00AEEF'
          },
          total_customer_costs: {
            copy: 'Customer',
            color: '#542667'
          },
          'total_operating_expenses_general_& administrative': {
            copy: 'General & Administrative',
            color: '#00AEEF',
          },
          'total_operating_expenses_product_development': {
            copy: 'Product',
            color: '#542667',
          },
          'total_operating_expenses_sales': {
            copy: 'Sales',
            color: '#D90000',
          },
          'total_operating_expenses_marketing': {
            copy: 'Marketing',
            color: '#BA68C8',
          },
          total_operations: {
            copy: 'OpEx',
            color: '#69B144'
          },
          total_other_costs: {
            copy: 'Other Expenses',
            color: '#FFB74D'
          },
        }

        let pnlKeys = Object.keys(pnlKeysData)

        pnlKeys.forEach((key) => {
          let data = []
          let total = 0

          if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
            props.yearRange.forEach(y => {
              if (calcs?.you?.[key]) {
                data.push(calcs.you[key][y] ?? null)
              } else {
                data.push(null)
              }
            })
          } else if (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') {
            [props.year - 1, props.year].forEach(y => {
              if (monthlyCalcs['you']?.[key]?.[y]) {
                let monthVals = getYTDMonths(monthlyCalcs['you'][key][y], ytd_months)
                let ytdVal = monthVals.reduce((a, b) => a + b, 0)
                data.push(ytdVal)
              } else {
                data.push(null)
              }
            })
          } else if (props.displayColumnsBy === 'Months') {
            if (monthlyCalcs?.you?.[key]) {
              data = Object.values(monthlyCalcs.you[key]?.[selectedYear]).slice(0, endMonthOfSelectedYear)
            }
          }

          total = data.reduce((a, b) => a + b, 0)

          if (key === 'total_revenue') {
            youData.push({
              color: pnlKeysData[key].color,
              name: pnlKeysData[key].copy,
              type: 'spline',
              data: data,
              zIndex: 10,
            })
          } else {
            if (total !== 0) {
              youData.push({
                color: pnlKeysData[key].color,
                name: pnlKeysData[key].copy,
                type: 'column',
                data: data,
                zIndex: 1,
              })
            }
          }
        })

        let pnlComboOptions = getPNLComboOptions(chartProps, youData);
        return (
          <div key='pnl_combo_view' className='' style={allStyles}>
            <HighchartsReact key='pnl_combo_view' ref={setNewRef} containerProps={pnlComboProps} highcharts={Highcharts} options={pnlComboOptions} />
          </div>
        )
      } else if (l.i.includes('_trend')) {
        let parentMetric = l['metricRow'];
        let allStyles = { ...positionStyles, display: 'flex' }
        let pnlComboProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' } }
        let metricKey = l.i.includes('total_revenue') ? 'total_revenue' : 'operating_profit'
        let chartProps = {
          i: l.i,
          monthlyData: props.trendData?.[metricKey] || {},
          year: props.year,
          title: parentMetric['copy'],
          months: props.monthLabels || null,
          pdf: props.pdf || false,
          endMonthOfSelectedYear: endMonthOfSelectedYear
        };

        let trendOptions = getTrendChart(chartProps)
        return (
          <div key={l.i} className='' style={allStyles}>
            <HighchartsReact key={l.i} ref={setNewRef} containerProps={pnlComboProps} highcharts={Highcharts} options={trendOptions} />
          </div>
        )
      } else if (l.i.includes('_gauges')) {
        let allStyles = { ...positionStyles, display: 'flex', flexDirection: 'row' }
        return (
          <div key={l.i} className='dashboard-gauges' style={allStyles}>
            {gaugeKeys[l.i].map((metricKey, i) => {
              let gaugeProps = { style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: `gauge-${i}`, id: `gauge-${i}` }
              let gaugeData = 0;
              if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                gaugeData = Math.round(calcs.you?.[metricKey]?.[props.year])
              }
              if (props.displayColumnsBy === 'Months' || props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') {
                const peerviewMetrics = peerviewMetricsYears?.[props.year]?.['you'];
                if (peerviewMetrics && peerviewMetrics.hasOwnProperty(metricKey)) {
                  gaugeData = Math.round(peerviewMetrics[metricKey]);
                } else {
                  gaugeData = 0;
                }
              }

              let gaugeOptions = getGaugeOptions(metricKey, gaugeData, props.pdf);
              return (
                <HighchartsReact key={metricKey} ref={setNewRef} containerProps={gaugeProps} highcharts={Highcharts} options={gaugeOptions} />
              )
            })}
          </div>
        )
      } else if (l.i === 'you_pie' || l.i === 'compare_pie') {
        let group;
        let pieClass = props.page === 'money' ? 'money-expenses-charts' : '';
        let pieKey = l.i;
        if (l.i === 'compare_pie' && props.compareWith === 'None' || l.i === 'compare_pie' && props.compareWith === 'Default:None') {
          return (
            <div key={pieKey} className={pieClass} style={positionStyles}><div style={{ 'fontSize': '18px', 'color': 'black', 'padding': '5px' }}>Compare With Expenses Pie Chart</div></div>
          )
        } else {
          let pieTitle = ''
          let year = props.year;
          if (l.i === 'you_pie') {
            group = 'you'
            pieTitle = pieExpenseTitles['you']
          } else {
            if (props.compareWith === 'Peers' || props.compareWith === 'Default:Peers') {
              group = 'avg'
              pieTitle = pieExpenseTitles['avg']
            } else if (compareWithRowKeys[props.compareWith]) {
              group = compareWithRowKeys[props.compareWith]
              pieTitle = `${props.compareWith} Expenses`
            } else if (props.compareWith === 'Practice') {
              group = 'practice_avg'
              pieTitle = pieExpenseTitles['practice_avg']
            } else if (props.compareWith === 'NSCHBC') {
              group = 'nschbc'
              pieTitle = pieExpenseTitles['nschbc']
            } else if (props.compareWith === 'YOY' || props.compareWith === 'Default:YOY') {
              group = 'yoy'
              pieTitle = pieExpenseTitles['yoy']
            } else if (props.compareWith && props.compareWith.includes('Forecast')) {
              group = 'forecast'
              pieTitle = props.monthlyCompareWithTitle + ' Expenses'
            }
          }

          let pieCalcs;
          if (group === 'yoy') {
            year = previousYear
            pieCalcs = getCalcsGroupMonthly('yoy');
          } else if (props.reportPeriod === 'Year to Date' && group !== 'forecast') {
            pieCalcs = getCalcsGroupMonthly(group);
          } else if (props.displayColumnsBy === 'Months' && group !== 'forecast') {
            pieCalcs = getCalcsGroupMonthly(group);

            if (group === 'yoy') {
              year = previousYear
            }
          } else if (props.displayColumnsBy === 'Years' && group !== 'forecast') {
            pieCalcs = getCalcsGroupAnnual(group)
          } else if (group === 'forecast') {
            let forecastRevenue = props.forecastVals?.['total_revenue'];
            year = forecastRevenue ? Object.keys(forecastRevenue)[0] : null;
            pieCalcs = props.forecastVals
          }

          const pieProps = {
            group: group,
            commonSize: pagePies[props.page].commonSize,
            data: pieCalcs,
            displayColumnsBy: props.displayColumnsBy,
            keys: pagePies[props.page].keys,
            page: props.page,
            pdf: props.pdf,
            reportPeriod: props.reportPeriod,
            subtitle: pagePies[props.page].subtitle,
            title: pieTitle,
            year: year,
            ytdMonths: ytd_months
          }

          let pieOptions = getPieOptions(pieProps);
          return (
            <div key={pieKey} className={pieClass} style={positionStyles}><HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: pieKey, id: pieKey }} highcharts={Highcharts} options={pieOptions} /></div>
          )
        }
      } else if (l.i === 'you_compare_stacked_column') {
        let finalCategories = ['You']
        props.compareWith === 'Peers' ? finalCategories.push('Peers') : props.compareWith === 'Practice' ? finalCategories.push('Practice') : finalCategories.push('YOY');

        let chartProps = {
          i: l.i,
          aggregateYTDDate: props.aggregateYTDDate || null,
          companyYTDDate: props.companyYTDDate || null,
          format: 'percent',
          compareWith: props.compareWith || null,
          displayColumnsBy: props.displayColumnsBy || null,
          fiscalYearEnd: props.fiscalYearEnd || '12/31',
          key: 'you_compare_stacked_column',
          months: props.monthLabels || null,
          page: props.page,
          pdf: props.pdf || false,
          reportPeriod: props.reportPeriod,
          title: 'People Expenses Comparison',
          categories: finalCategories,
          years: (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') ? [props.year - 1, props.year] : props.yearRange,
        }
        let stackedData = buildPeopleExpenses(chartProps)
        let chartOptions = getStackedColumnOptions(chartProps, stackedData);
        return (
          <div key={'you_compare_stacked_column'} style={positionStyles}><HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: 'you_compare_stacked_column', id: 'you_compare_stacked_column' }} highcharts={Highcharts} options={chartOptions} /></div>
        )
      } else if (l.i === 'map_of_client_number') {
        let mapOptions = getUSMapOptions(props.calculations);
        return (
          <div key={'map_of_client_number'} style={positionStyles}>
            <button className='no-drag lock-btn' onClick={() => props.handleToggleDraggable('map_of_client_number', '', null, props?.customKey)}>{l.isDraggable ? <FontAwesomeIcon icon={faLockOpen} /> : <FontAwesomeIcon icon={faLock} />}</button>
            <HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: `map_of_client_number` }} highcharts={Highcharts} constructorType={'mapChart'} options={mapOptions} />
          </div>
        )
      } else if (l.layout && l.layout.length > 1) {
        let parentInfo = l['metricRow'] ? l['metricRow'] : l
        let parentStyles = l['metricRow'] ? l['metricRow']['styles'] : l['styles'] ? l['styles'] : {}
        let parentNotes = l['metricRow'] ? l['metricRow']['notes'] : ''

        return (
          <div key={l.i} style={positionStyles}>
            <ChildDashboard
              id={l.i}
              childWidth={l.w}
              childHeight={l.h}
              parentLayout={props.dashboardLayout}
              aggregateData={props.aggregateData}
              reportBuilder={props.reportBuilder || null}
              customKey={props.customKey || null}
              customLayout={props.customLayout || false}
              aggregateYTDDate={props.aggregateYTDDate}
              calcsAvgType={props.calcsAvgType}
              clientName={props.clientName}
              companyYTDDate={props.companyYTDDate}
              compareWith={props.compareWith}
              dashboardLayout={l.layout}
              displayColumnsBy={props.displayColumnsBy}
              monthlyCompareWithTitle={props.monthlyCompareWithTitle}
              forecastVals={props.forecastVals}
              handleEditChartModal={props.handleEditChartModal}
              handleMetricNotes={props.handleMetricNotes}
              handleOnLayoutChange={props.handleOnLayoutChange}
              handleToggleDraggable={props.handleToggleDraggable}
              calendarYearEnd={props.calendarYearEnd}
              fiscalYearEnd={props.fiscalYearEnd}
              monthLabels={props.monthLabels}
              naicsCode={props.naicsCode}
              tabFilters={props.tabFilters}
              page={props.page}
              pdf={props.pdf}
              positionStyles={positionStyles}
              rankingData={props.rankingData}
              reportPeriod={props.reportPeriod}
              year={props.year}
              yearRange={props.yearRange}
              parentDashBoardInfo={parentInfo}
              parentNotes={parentNotes}
              parentStyles={parentStyles}
            />
          </div>
        )
      } else {
        let chart;
        let page = props.page
        let parentMetric = l['metricRow'];
        if (page === 'practice') {
          chart = pageCharts['practice']['dashboard_items'].find(c => c.key === l.i);
        } else if ((page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric.sheet)) || page === 'customers') {
          chart = pageCharts['customers']['dashboard_items'].find(c => c.key === l.i);
        } else if ((page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric.sheet)) || page === 'people') {
          chart = pageCharts['people'].find(c => c.key === l.i);
        } else {
          chart = moneyCharts[props.page].find(c => c.key === l.i);
          if (!chart) { chart = moneyCharts['peerview_charts'].find(c => c.key === l.i) }
        }


        if (page === 'money' && ['people_financial_detail', 'people_kpi'].includes(parentMetric?.sheet)) {
          page = 'people'
        } else if (page === 'money' && ['customers_financial_detail', 'customers_kpi'].includes(parentMetric?.sheet)) {
          page = 'customers'
        }
        let finalFormat = chart.format
        if ((parentMetric?.sheet === 'people_financial_detail' && props.displayColumnsBy === 'Months') || (parentMetric?.sheet === 'people_financial_detail' && props.reportPeriod === 'Year to Date')) {
          finalFormat = 'money'
        } else if (parentMetric?.sheet === 'people_financial_detail' && props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
          finalFormat = 'percent'
        }

        if (chart) {
          let chartKey = chart.key
          let youData, compareData, chartOptions;
          let chartProps = {
            i: l.i,
            aggregateYTDDate: props.aggregateYTDDate || null,
            companyYTDDate: props.companyYTDDate || null,
            format: finalFormat,
            headerCols: chart.headerCols,
            compareWith: props.compareWith || null,
            displayColumnsBy: props.displayColumnsBy || null,
            fiscalYearEnd: props.fiscalYearEnd || '12/31',
            key: chart.key,
            keys: chart.keys || null,
            metricKey: chart.metricKey || null,
            months: props.monthLabels || null,
            onManyReports: parentMetric ? parentMetric['onManyReports'] : false,
            page: page,
            pdf: props.pdf || false,
            percentOfRevenueKey: chart.percentOfRevenueKey || null,
            reportPeriod: props.reportPeriod,
            title: titleSetter(chart),
            subtitle: chart.subtitle,
            styles: l.styles || chart.styles,
            trailing12Key: chart.trailing12Key || null,
            x: chart.x,
            y: chart.y,
            years: (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date') ? [props.year - 1, props.year] : props.yearRange,
          }
          switch (chart.chartType) {
            case 'customMultipleTables':
              if (props.pdf) {
                positionStyles['display'] = 'flex'
                positionStyles['justifyContent'] = 'center'
                positionStyles['alignItems'] = 'center'
              }
              return (
                <div key={chartKey} style={positionStyles}>
                  {customMultipleCharts(chartProps)}
                </div>
              )
              break;
            case '3DBubble':
              chartOptions = get3DBubbleChartOptions(chartProps, props.calculations);
              break;
            case 'quadrantBubble':
              if (props.page === 'practice') {
                chartOptions = getQuadrantOptions(chartProps, props.calculations);
              }
              if (props.page === 'money') {
                let chartData = { name: props.naicsCode, data: [] };
                let dataObj = { name: props.clientName, color: '#69B144' }
                if (props.displayColumnsBy === 'Years' && props.reportPeriod !== 'Year to Date') {
                  dataObj.x = Math.round(calcs.you[chartProps.keys[0]][props.year])
                  dataObj.y = Math.round(calcs.you[chartProps.keys[1]][props.year])
                  dataObj.z = calcs.you['total_revenue'][props.year]
                  chartData.data.push(dataObj);
                }
                if (props.displayColumnsBy === 'Months' || (props.displayColumnsBy === 'Years' && props.reportPeriod === 'Year to Date')) {
                  const peerviewMetrics = peerviewMetricsYears[props.year]['you'];
                  dataObj.x = peerviewMetrics.hasOwnProperty(chartProps.keys[0]) ? peerviewMetrics[chartProps.keys[0]] : 0;
                  dataObj.y = peerviewMetrics.hasOwnProperty(chartProps.keys[1]) ? peerviewMetrics[chartProps.keys[1]] : 0;
                  dataObj.z = props.displayColumnsBy === 'Months' && monthlyCalcs?.you?.['total_revenue']?.[selectedYear] ? objReducer(monthlyCalcs.you['total_revenue'][selectedYear].slice(0, endMonthOfSelectedYear)) : getYTDMonths(monthlyCalcs['you']['total_revenue'][props.year], ytd_months).reduce((a, b) => a + b, 0);
                  chartData.data.push(dataObj);
                }
                chartOptions = getQuadrantOptions(chartProps, chartData)
              }
              break;
            case 'practiceText':
              return buildFocusedClients()
              break;
            case 'multiDataBarChart':
              chartOptions = getMultiDataBarChartOptions(chartProps, props['rankingData'])
              break;
            case 'rankingTable':
              return buildRankingTable(positionStyles, chartProps, props['rankingData'])
              break;
            case 'scatterPlot':
              chartOptions = getScatterPlotOptions(chartProps, props.calculations);
              break;
            case 'editableChart':
            case 'lineBar':
              youData = buildYouLineOrColData(chartProps);
              compareData = chartProps.compareWith !== 'None' && chartProps.compareWith !== 'Default:None' ? buildCompareLineOrColData(chartProps) : null;
              chartOptions = getLineOrColOptions(chartProps, youData, compareData, props.fiscalYearEnd);
              break;
            case 'verticalBars':
              youData = buildVerticalBarData(chartProps, 'you');
              compareData = chartProps.compareWith !== 'None' && chartProps.compareWith !== 'Default:None' ? buildVerticalBarData(chartProps, chartProps.compareWith) : null;
              chartOptions = getVerticalBarChartOptions(chartProps, youData, compareData);
              break;
            case 'horizontalBars':
              let xCategories = chart.keys.map((k) => COPY[k]);
              let hBarSeries = buildHorizonalBarSeries(chartProps);
              chartOptions = getHorizontalBarOptions(chartProps, xCategories, hBarSeries);
              break;
            case 'stackedBars':
              chartProps['categories'] = chartProps.displayColumnsBy === "Years" ? chartProps.years : chartProps.months,
                youData = buildAPARAgingSeries(chartProps)
              chartOptions = getStackedColumnOptions(chartProps, youData);
              break;
            case 'lines':
              let seriesTitles = chart.keys.map((k) => COPY[k])
              let lineSeries = buildLineSeries(chartProps)
              chartOptions = getLineChartOptions(chartProps, seriesTitles, lineSeries);
              break;
            case 'noChart':
              let value = costOfTurnover();
              return (
                <div className='cost-of-turnover' key={chartKey}>
                  <h3>Cost of Turnover</h3>
                  <p>(Based on S.H.R.M. Standards)</p>
                  <div className='turnover-border'>
                    <h2 className='cost-of-turnover-value'>
                      {parseMoney(Math.abs(value))}
                    </h2>
                    <p>{value < 0 ? 'Less' : 'More'} Than Your Peers</p>
                  </div>
                </div>
              )
          }
          if (chart.dragTogglable) {
            return (
              <div key={chartKey} style={positionStyles}>
                {props.pdf ? null : <button className='no-drag lock-btn' onClick={() => props.handleToggleDraggable(chartKey, '', null, props?.customKey)}>{l.isDraggable ? <FontAwesomeIcon icon={faLockOpen} /> : <FontAwesomeIcon icon={faLock} />}</button>}
                <HighchartsReact ref={setNewRef} containerProps={{ style: { width: '100%', height: '100%', borderRadius: '15px', overflow: 'hidden' }, key: chartKey, id: chartKey }} highcharts={Highcharts} options={chartOptions} />
              </div>
            )
          } else {
            return (
              <div className="reports-dashboard-chart" key={chartKey} style={positionStyles}>
                <button className='no-drag edit-dash-item-btn' onClick={() => props.handleEditChartModal('open', chartProps, chartOptions)}><FontAwesomeIcon icon={faPencil} /></button>
                <HighchartsReact ref={setNewRef} containerProps={{ style: { width: "100%", height: "100%" }, key: chartKey, id: chartKey }} highcharts={Highcharts} options={chartOptions} />
              </div>
            )
          }
        }
        return null
      }
    })

  }, [props.dashboardLayout, props.year, props.calculations, props.myNotes, calcs, monthlyCalcs])

  if (props.pdf) {
    if (props.dashboardLayout.length > 0) {
      let heightStyle = {
        height: `248mm`
      }

      return (
        <div className='parent-dash-portrait-pdf' style={heightStyle}>
          {layoutItems}
        </div>
      )
    }
  } else {
    return (
      <ResponsiveGridLayout
        className='parent-layout'
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        draggableCancel=".no-drag"
        layouts={{ lg: props.dashboardLayout }}
        cols={{ lg: 6, md: 6, sm: 6, xs: 6, xxs: 6 }}
        rowHeight={210}
        isDraggable={true}
        isDroppable={true}
        isResizable={true}
        onResizeStop={(layout, oldItem, newItem) => {
          // layout = layout.map(l => {
          //   let gridItem = props.dashboardLayout.find(d => d.i === l.i)
          //   if (gridItem?.layout) {
          //     l = resizeChildLayout(gridItem, l)
          //   }
          //   return l
          // })
          // Force reflow() on specific item when user resizes it.
          let item = oldItem ? oldItem : newItem;
          let checkChartRefs = _.isEmpty(chartRefs)
          if (!checkChartRefs && item && chartRefs[item.i] && chartRefs[item.i].chart) {
            chartRefs[item.i].chart.reflow()
          }
          window.dispatchEvent(new Event('resize'))
        }}
        onLayoutChange={(layout) => {
          layout = layout.map(l => {
            let gridItem = props.dashboardLayout.find(d => d.i === l.i)
            if (gridItem?.layout) {
              l = resizeChildLayout(gridItem, l)
            }
            return l
          })

          if (props.customLayout) {
            // Using handleCustomLayoutChange
            props.handleOnLayoutChange(props.customKey, 'parentMyDashBoard', layout)
          } else {
            props.handleOnLayoutChange('parentMyDashBoard', layout)
          }
          // Force reflow() on highcharts when different display columns by filter submits
          // For some odd reason the highcharts are not resizing to new layout like before
          let checkChartRefs = _.isEmpty(chartRefs)
          if (!checkChartRefs) {
            for (const chartRef in chartRefs) {
              if (chartRefs[chartRef].chart) {
                let chartInfo = layout.find(l => l.i === chartRef)
                if (chartInfo) {
                  let chartWidth = chartInfo.w * 214;
                  let chartHeight = chartInfo.h * 208;
                  chartRefs[chartRef].chart.setSize(chartWidth, chartHeight)
                } else {
                  chartRefs[chartRef].chart.reflow();
                }
              }
            }
          }

        }}
      >
        {layoutItems}
      </ResponsiveGridLayout>
    )
  }
}
export default ParentDashboard;